/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AccrualGroupResponse } from '../api-models';
// @ts-ignore
import { AddClockPermissionResponse } from '../api-models';
// @ts-ignore
import { AddEmployeeAuthorizationLaborLevelRequest } from '../api-models';
// @ts-ignore
import { AddEmployeeClockInfoRequest } from '../api-models';
// @ts-ignore
import { AddEmployeeHistoryTypeRequest } from '../api-models';
// @ts-ignore
import { AddEmployeeStatusRequest } from '../api-models';
// @ts-ignore
import { AddEmployeeWorkPatternRequest } from '../api-models';
// @ts-ignore
import { AdjustEmployeeShift } from '../api-models';
// @ts-ignore
import { AuditResponse } from '../api-models';
// @ts-ignore
import { BaseScheduleGroupResponse } from '../api-models';
// @ts-ignore
import { ClockIdDuplicateCheckResponse } from '../api-models';
// @ts-ignore
import { CreateEmployeeJournalRequest } from '../api-models';
// @ts-ignore
import { CreateEmployeeRequest } from '../api-models';
// @ts-ignore
import { CreateEmployeeResponse } from '../api-models';
// @ts-ignore
import { DeleteEmployeeShift } from '../api-models';
// @ts-ignore
import { DeleteEmployeeWorkPatternRequestV2 } from '../api-models';
// @ts-ignore
import { EffectiveDateConfigurationResponse } from '../api-models';
// @ts-ignore
import { EffectiveDateType } from '../api-models';
// @ts-ignore
import { EmployeeAuthorizationLaborLevelItem } from '../api-models';
// @ts-ignore
import { EmployeeAuthorizationResponse } from '../api-models';
// @ts-ignore
import { EmployeeClockInfoListResponse } from '../api-models';
// @ts-ignore
import { EmployeeClockInfoResponse } from '../api-models';
// @ts-ignore
import { EmployeeContactInfoResponse } from '../api-models';
// @ts-ignore
import { EmployeeCustomTabsResponseV2 } from '../api-models';
// @ts-ignore
import { EmployeeCustomValuesResponseV2 } from '../api-models';
// @ts-ignore
import { EmployeeEmploymentGeneralResponse } from '../api-models';
// @ts-ignore
import { EmployeeEmploymentGeneralUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeeGroupsPageResult } from '../api-models';
// @ts-ignore
import { EmployeeHeaderDetails } from '../api-models';
// @ts-ignore
import { EmployeeHealthResponse } from '../api-models';
// @ts-ignore
import { EmployeeHealthUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeeHistoryResponse } from '../api-models';
// @ts-ignore
import { EmployeeHistoryType } from '../api-models';
// @ts-ignore
import { EmployeeHistoryTypeResponse } from '../api-models';
// @ts-ignore
import { EmployeeI9DocumentsResponse } from '../api-models';
// @ts-ignore
import { EmployeeI9DocumentsUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeeIdDuplicateCheckResponse } from '../api-models';
// @ts-ignore
import { EmployeeInServiceAddRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeeInServiceItem } from '../api-models';
// @ts-ignore
import { EmployeeJournalItem } from '../api-models';
// @ts-ignore
import { EmployeeJournalResponse } from '../api-models';
// @ts-ignore
import { EmployeeLicenseResponse } from '../api-models';
// @ts-ignore
import { EmployeeLicenseUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeeLockStatus } from '../api-models';
// @ts-ignore
import { EmployeeMainInfoUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeeMainTabResponse } from '../api-models';
// @ts-ignore
import { EmployeeMiscSettingsResponse } from '../api-models';
// @ts-ignore
import { EmployeePayRateAddRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeePayRateUpdateRequestV2 } from '../api-models';
// @ts-ignore
import { EmployeePayRatesResponse } from '../api-models';
// @ts-ignore
import { EmployeePersonalInfoResponse } from '../api-models';
// @ts-ignore
import { EmployeeShiftItem } from '../api-models';
// @ts-ignore
import { EmployeeShiftRequest } from '../api-models';
// @ts-ignore
import { EmployeeStatusResponse } from '../api-models';
// @ts-ignore
import { EmployeeWorkPatternConfigurationResponse } from '../api-models';
// @ts-ignore
import { EmployeeWorkPatternItem } from '../api-models';
// @ts-ignore
import { FacilityTimeClockResponse } from '../api-models';
// @ts-ignore
import { FindEmployeeGroupRequest } from '../api-models';
// @ts-ignore
import { FindEmployeeRequestV2 } from '../api-models';
// @ts-ignore
import { GroupedEmployeePageResult } from '../api-models';
// @ts-ignore
import { HolidayGroupResponse } from '../api-models';
// @ts-ignore
import { InServiceListResponse } from '../api-models';
// @ts-ignore
import { LaborLevelFilterType } from '../api-models';
// @ts-ignore
import { LaborLevelResponse } from '../api-models';
// @ts-ignore
import { LaborLevelResponseBase } from '../api-models';
// @ts-ignore
import { LoggedInUserDetailResponse } from '../api-models';
// @ts-ignore
import { NextAvailableEmployeeIdResponse } from '../api-models';
// @ts-ignore
import { OpenShiftsBusinessObjectsResponseEmployeeCenterEmployeeStatusTypeResponse } from '../api-models';
// @ts-ignore
import { PayPeriodGroupResponse } from '../api-models';
// @ts-ignore
import { PayRateSettingsResponse } from '../api-models';
// @ts-ignore
import { PayRuleResponse } from '../api-models';
// @ts-ignore
import { PayTypeEntityResponse } from '../api-models';
// @ts-ignore
import { ProblemDetails } from '../api-models';
// @ts-ignore
import { ProfilePictureUrlResponse } from '../api-models';
// @ts-ignore
import { RecalculateButtonStateResponse } from '../api-models';
// @ts-ignore
import { SetEmployeeClockInfoAllAssignmentsRequest } from '../api-models';
// @ts-ignore
import { SetEmployeeClockInfoAssignmentsRequest } from '../api-models';
// @ts-ignore
import { TaDashboardResponse } from '../api-models';
// @ts-ignore
import { UndoAllResult } from '../api-models';
// @ts-ignore
import { UndoResult } from '../api-models';
// @ts-ignore
import { UndoStackResponse } from '../api-models';
// @ts-ignore
import { UpdateEmployeeAccrualGroupRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeAuthorizationLaborLevelRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeAuthorizationRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeBaseScheduleGroupRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeClockInfoRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeContactInfoRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeCustomValuesRequestV2 } from '../api-models';
// @ts-ignore
import { UpdateEmployeeHolidayGroupRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeIdRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeJournalRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeLaborLevelsRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeMiscSettingsRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeePayRuleRequest } from '../api-models';
// @ts-ignore
import { UpdateEmployeeShift } from '../api-models';
// @ts-ignore
import { UpdateEmployeeStatusRequest } from '../api-models';
// @ts-ignore
import { UpdatePersonalInfoRequestV2 } from '../api-models';
/**
 * EmployeeV2Api - axios parameter creator
 * @export
 */
export const EmployeeV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The sibling of `checkDuplicateId`, with the same role-only authorization and the same  accepted risk: an existence probe on a non-secret, human-typed ID. It names no one. Create names  the holder when it refuses, but only after the caller\'s role at the new employee\'s labor levels  allows adding an employee with a clock ID; this call checks the JWT role alone. The answer is  the rule creation and the Clock Info tab\'s add enforce, so a free ID here is one the create call  will accept (in multi-facility mode per facility: HandPunch and Accuface route a row by its  holder\'s facility and send an all-clocks employee everywhere, so it does not rule out the same  ID under another facility). Call it while the Clock ID is typed. On submit, call create: it  refuses a taken ID with the holder\'s name and what to do, which this call cannot show.
         * @summary SPD-5664: returns whether a clock ID is already used by another employee, so the Add Employee  form can warn while the ID is typed instead of after the employee is saved.
         * @param {number} [clockId] The clock ID to check; 0 or omitted answers 400.
         * @param {number} [facilityId] The facility the employee will be created under, the Facility selector\&#39;s value the create  request carries as &#x60;facilityId&#x60; (the same facility labor level ID &#x60;checkDuplicateId&#x60;  takes); required in multi-facility mode, null or omitted otherwise.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesCheckDuplicateClockIdGet: async (clockId?: number, facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/checkDuplicateClockId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clockId !== undefined) {
                localVarQueryParameter['clockId'] = clockId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization is role-only (the `[Authorize(Roles = ...)]` below) — unlike the create  path\'s `CheckLaborLevelAuthorizationAsync`, nothing here verifies the caller has any standing  at facilityId itself. A FacilityManager (or Support/Admin/System) token  scoped to one facility can pass a different facilityId and probe  employee-ID existence there, and in single-facility mode an omitted facilityId  answers tenant-wide. Accepted deliberately, matching `nextAvailableId`\'s existing,  already-shipped shape (SPD-5697 review) — this is an existence probe on a non-secret,  human-typed ID, not a data read, and tightening it would mean duplicating the labor-level  authorization engine on a read endpoint. Revisit if that calculus changes.
         * @summary Returns whether the given employee ID is already in use within a facility.
         * @param {string} [employeeId] The employee ID to check.
         * @param {number} [facilityId] Required in multi-facility mode; pass null or omit for single-facility. This is the labor  level ID for the employee\&#39;s Facility labor level (the same value used to populate the  \&quot;Facility\&quot; selector on the employee create/edit form) — not the SaaS tenant\&#39;s facility GUID  or any other facility identifier. A value from the wrong ID space is rejected with 400  rather than silently scoping to a facility that doesn\&#39;t exist.
         * @param {number} [excludePkEmployeeId] Pass the employee\&#39;s own PkEmployeeId when pre-checking a rename on the edit-employee-ID  field, so their own current ID isn\&#39;t reported as a duplicate of itself. Omit when  pre-checking a new employee\&#39;s ID at creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesCheckDuplicateIdGet: async (employeeId?: string, facilityId?: number, excludePkEmployeeId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/checkDuplicateId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeId !== undefined) {
                localVarQueryParameter['employeeId'] = employeeId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (excludePkEmployeeId !== undefined) {
                localVarQueryParameter['excludePkEmployeeId'] = excludePkEmployeeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns clock-info permission flags for the logged-in user given exactly 10 labor-level IDs.  Mirrors ta-web `POST /api/Employee/AddClockPermission`.
         * @param {Array<number>} [requestBody] An array of exactly 10 labor level PKs corresponding to the clock ID\&#39;s labor level slots.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesClockInfoPermissionsPost: async (requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/clockInfoPermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new employee (heaviest write-side port of TaAPI `EmployeeController.CreateEmployee`).
         * @param {CreateEmployeeRequest} [createEmployeeRequest] The create-employee request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesCreatePost: async (createEmployeeRequest?: CreateEmployeeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The facility\'s custom-tab definitions: tabs, fields and dropdown options. Carries no  employee id, so the class-level `RequireSelfOrManager` filter no-ops here and the  caller\'s own `EmployeeCustomView` is the gate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesCustomTabsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/custom-tabs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the Licensing tab. Replaces TaAPI  `PUT /api/Employee/Employment/EmployeeLicense`. Returns the hydrated  OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeLicenseResponse.
         * @param {EmployeeLicenseUpdateRequestV2} [employeeLicenseUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesEmploymentEmployeeLicensePut: async (employeeLicenseUpdateRequestV2?: EmployeeLicenseUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/employment/employeeLicense`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeLicenseUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the General employment tab. Replaces TaAPI  `PUT /api/Employee/Employment/General`. Returns `true` on success.
         * @param {EmployeeEmploymentGeneralUpdateRequestV2} [employeeEmploymentGeneralUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesEmploymentGeneralPut: async (employeeEmploymentGeneralUpdateRequestV2?: EmployeeEmploymentGeneralUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/employment/general`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeEmploymentGeneralUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the Health tab. Replaces TaAPI `PUT /api/Employee/Employment/Health`.  Returns the hydrated OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeHealthResponse.
         * @param {EmployeeHealthUpdateRequestV2} [employeeHealthUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesEmploymentHealthPut: async (employeeHealthUpdateRequestV2?: EmployeeHealthUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/employment/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeHealthUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the I-9 Documents tab. Replaces TaAPI  `PUT /api/Employee/Employment/I9Documents`. Returns the hydrated  OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeI9DocumentsResponse.
         * @param {EmployeeI9DocumentsUpdateRequestV2} [employeeI9DocumentsUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesEmploymentI9DocumentsPut: async (employeeI9DocumentsUpdateRequestV2?: EmployeeI9DocumentsUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/employment/i9Documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeI9DocumentsUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the authorized employee groups for the current employee based on the provided grouping and filter request.
         * @param {FindEmployeeGroupRequest} [findEmployeeGroupRequest] The employee group search and filter request. When the request body is null, an empty request is used  to keep the endpoint behavior stable and avoid null-reference issues.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesGroupsPost: async (findEmployeeGroupRequest?: FindEmployeeGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findEmployeeGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the labor levels for the given filter type used for employee filtering.  Replaces ta-web\'s `GET /api/Employee/BudgetGroupLaborLevelsForFilter` and  `GET /api/Employee/DepartmentLaborLevelsForFilter`.
         * @param {LaborLevelFilterType} type Which configured labor level index to resolve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesLaborLevelsForFilterTypeGet: async (type: LaborLevelFilterType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('apiV2EmployeesLaborLevelsForFilterTypeGet', 'type', type)
            const localVarPath = `/api/v2/employees/laborLevelsForFilter/{type}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Release All Locks — every lock, every owner. Gated on the caller\'s legacy TA role being  the Administrator built-in (`Role.IsAdministrator`), matching LegacyApp, which only  shows this command when `role.IsAdministrator` (MainFormRibbonSetup.cs:136-137). The  check runs in the service; an identity-role restriction here would 403 every facility  caller, because `UserRoles.Admin` is a SaaS platform role facility users never carry  (SPD-5803).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesLocksDelete: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/locks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Release My Locks — all of the caller\'s locks, all sessions (legacy built-in).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesLocksMineDelete: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/locks/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns identity and role-flag details for the currently authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesMeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the signed-in employee\'s own personal info (emergency contact, home address, email,  home phone) for the mobile / self-service surface.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesMePersonalInfoGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/me/personal-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Self-service update of the authenticated employee\'s own personal info — address, emergency  contact, email and home phone. The caller is resolved from the JWT (mobile `me` route),  and the mobile client wraps its payload in a `body` envelope. Ports the mobile contact  update that had no V2 equivalent (SPD-5482).
         * @param {UpdatePersonalInfoRequestV2} [updatePersonalInfoRequestV2] The personal-info update, wrapped in a &#x60;body&#x60; envelope.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesMePersonalInfoPut: async (updatePersonalInfoRequestV2?: UpdatePersonalInfoRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/me/personal-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePersonalInfoRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization is role-only — nothing verifies the caller has any standing at  facilityId itself. Same accepted-risk decision as `checkDuplicateId`  (SPD-5697 review): an existence probe on a non-secret, human-typed ID, not a data read.
         * @summary Returns the next available employee ID within a facility.
         * @param {number} [facilityId] Facility to scope the search. Required in multi-facility mode; pass null or omit for single-facility.
         * @param {number} [startingFrom] When provided, returns the smallest integer ≥ this value not already in use.  When null, returns max existing numeric ID + 1.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesNextAvailableIdGet: async (facilityId?: number, startingFrom?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/nextAvailableId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (startingFrom !== undefined) {
                localVarQueryParameter['startingFrom'] = startingFrom;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the accrual group for the specified employee with an effective date.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeAccrualGroupRequest} [updateEmployeeAccrualGroupRequest] The request containing the accrual group information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAccrualGroupPut: async (pkEmployeeId: number, updateEmployeeAccrualGroupRequest?: UpdateEmployeeAccrualGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAccrualGroupPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/accrualGroup`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeAccrualGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all accrual groups accessible to the specified employee,  filtered by the employee\'s facility.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAccrualGroupsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAccrualGroupsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/accrualGroups`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The returned labor levels are filtered based on the employee\'s facility.  This endpoint always returns HTTP 200 with a consistent response shape.  Caching must be scoped per authenticated user and employee.
         * @summary Returns all labor levels available to the specified employee,  grouped by labor level index.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAllLaborLevelsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAllLaborLevelsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/allLaborLevels`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the Employee entity itself,  ordered by database timestamp ascending.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuditsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuditsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the data behind the employee\'s Authorizations tab — the  EmployeeAuthorization record merged with every EmployeeAuthorizationLaborLevel row —  ordered by database timestamp ascending (SPD-5600).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationAuditsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationAuditsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/authorization/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disables (soft-deletes) the authorization for the specified employee. Mirrors TaAPI  `DELETE {employeeId}/Authorization`.
         * @param {number} pkEmployeeId The employee whose authorization is removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationDelete: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationDelete', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/authorization`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns authorization settings and role-based permission flags for the specified employee.  When the caller\'s role lacks view permission, returns 200 with  `IsAuthorizationTabVisible = false` and all other fields at defaults.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/authorization`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clones an existing labor-level row on the employee\'s authorization into a new row.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} authorizationLaborLevelId The source row identifier to clone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost: async (pkEmployeeId: number, authorizationLaborLevelId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'authorizationLaborLevelId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost', 'authorizationLaborLevelId', authorizationLaborLevelId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/authorization/laborLevel/{authorizationLaborLevelId}/clone`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"authorizationLaborLevelId"}}`, encodeURIComponent(String(authorizationLaborLevelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-deletes a labor-level row from the employee\'s authorization.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} laborLevelId The authorization labor-level row identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete: async (pkEmployeeId: number, laborLevelId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'laborLevelId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete', 'laborLevelId', laborLevelId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/authorization/laborLevel/{laborLevelId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"laborLevelId"}}`, encodeURIComponent(String(laborLevelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a labor-level row on the employee\'s authorization. `EmployeeId` and  `AuthorizationLaborLevelId` are taken from the route, overriding the body.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} laborLevelId The authorization labor-level row identifier.
         * @param {UpdateEmployeeAuthorizationLaborLevelRequest} [updateEmployeeAuthorizationLaborLevelRequest] The update request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut: async (pkEmployeeId: number, laborLevelId: number, updateEmployeeAuthorizationLaborLevelRequest?: UpdateEmployeeAuthorizationLaborLevelRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'laborLevelId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut', 'laborLevelId', laborLevelId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/authorization/laborLevel/{laborLevelId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"laborLevelId"}}`, encodeURIComponent(String(laborLevelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeAuthorizationLaborLevelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a new labor-level row to the employee\'s authorization. `EmployeeId` is taken  from the route, overriding the body.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {AddEmployeeAuthorizationLaborLevelRequest} [addEmployeeAuthorizationLaborLevelRequest] The add request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost: async (pkEmployeeId: number, addEmployeeAuthorizationLaborLevelRequest?: AddEmployeeAuthorizationLaborLevelRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/authorization/laborLevel`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEmployeeAuthorizationLaborLevelRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Enables authorization for the specified employee (creates an authorization record with  generated defaults). Mirrors TaAPI `POST {employeeId}/Authorization`.
         * @param {number} pkEmployeeId The employee to enable authorization for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationPost: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/authorization`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the authorization details for the specified employee. Mirrors TaAPI  `PUT {employeeId}/Authorization`: the route employee ID overwrites the body\'s.
         * @param {number} pkEmployeeId The employee whose authorization is updated.
         * @param {UpdateEmployeeAuthorizationRequest} [updateEmployeeAuthorizationRequest] The update payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationPut: async (pkEmployeeId: number, updateEmployeeAuthorizationRequest?: UpdateEmployeeAuthorizationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/authorization`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeAuthorizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the role IDs available for the employee authorization combobox.  Always includes \"No Authorization (Built In)\"; includes \"Administrator (Built In)\"  only when the caller is an administrator.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationRolesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdAuthorizationRolesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/authorization/roles`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the base schedule group for the specified employee with an effective date.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeBaseScheduleGroupRequest} [updateEmployeeBaseScheduleGroupRequest] The request containing the base schedule group information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdBaseScheduleGroupPut: async (pkEmployeeId: number, updateEmployeeBaseScheduleGroupRequest?: UpdateEmployeeBaseScheduleGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdBaseScheduleGroupPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/baseScheduleGroup`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeBaseScheduleGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all base schedule groups accessible to the specified employee,  filtered by the employee\'s facility.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdBaseScheduleGroupsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdBaseScheduleGroupsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/baseScheduleGroups`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assigns or unassigns all facility-matched time clocks to/from the clock ID at the given index  by toggling the `AssignAllTimeClocks` flag and clearing all individual assignment rows.  Mirrors ta-web `PATCH /api/Employee/EmployeeClockInfo/AssignmentAll`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [index] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {SetEmployeeClockInfoAllAssignmentsRequest} [setEmployeeClockInfoAllAssignmentsRequest] Whether to assign or unassign all clocks.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch: async (pkEmployeeId: number, index?: number, setEmployeeClockInfoAllAssignmentsRequest?: SetEmployeeClockInfoAllAssignmentsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/clockInfo/assignmentAll`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setEmployeeClockInfoAllAssignmentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assigns or unassigns a single time clock to/from the clock ID at the given index.  Mirrors ta-web `PATCH /api/Employee/EmployeeClockInfo/Assignment`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [index] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {SetEmployeeClockInfoAssignmentsRequest} [setEmployeeClockInfoAssignmentsRequest] The time clock PK and whether it should be assigned or unassigned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch: async (pkEmployeeId: number, index?: number, setEmployeeClockInfoAssignmentsRequest?: SetEmployeeClockInfoAssignmentsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/clockInfo/assignments`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setEmployeeClockInfoAssignmentsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee clock info entry.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} clockIndex The zero-based index of the clock info entry.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet: async (pkEmployeeId: number, clockIndex: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'clockIndex' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet', 'clockIndex', clockIndex)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/clockInfo/{clockIndex}/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"clockIndex"}}`, encodeURIComponent(String(clockIndex)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the time clocks accessible to the specified employee based on facility matching.  An inactive clock, or one of an inactive group, is listed only while it is explicitly  assigned, flagged `isInactive` (SPD-6024).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/clockInfo/facilityTimeClocks`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns clock ID info for the specified employee at the given index.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [index] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoGet: async (pkEmployeeId: number, index?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/clockInfo`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the labor level IDs stored on the clock ID at the given index for an employee.  Requires `AllowMultipleClockIDs` to be enabled.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [index] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet: async (pkEmployeeId: number, index?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/clockInfo/laborLevels`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Writes the 10-element labor level FK array onto the clock ID at the given index.  Mirrors ta-web `PUT /api/Employee/EmployeeClockInfo/LaborLevels`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [index] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {Array<number>} [requestBody] Exactly 10 labor level PKs. Position i maps to &#x60;FkLaborLevel{i}Id&#x60;. Pass 0 to clear a slot.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut: async (pkEmployeeId: number, index?: number, requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/clockInfo/laborLevels`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lists every clock ID belonging to the specified employee, in the order the clock-scoped  endpoints index them.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoListGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoListGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/clockInfo/list`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a new clock ID record for the specified employee.  Mirrors ta-web `POST /api/Employee/EmployeeClockInfo`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {AddEmployeeClockInfoRequest} [addEmployeeClockInfoRequest] The add request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoPost: async (pkEmployeeId: number, addEmployeeClockInfoRequest?: AddEmployeeClockInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/clockInfo`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEmployeeClockInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing clock ID record for the specified employee.  Mirrors ta-web `PUT /api/Employee/EmployeeClockInfo`.  Only non-null request fields are applied (patch semantics).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [clockIndex] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {UpdateEmployeeClockInfoRequest} [updateEmployeeClockInfoRequest] The partial update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoPut: async (pkEmployeeId: number, clockIndex?: number, updateEmployeeClockInfoRequest?: UpdateEmployeeClockInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdClockInfoPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/clockInfo`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (clockIndex !== undefined) {
                localVarQueryParameter['clockIndex'] = clockIndex;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeClockInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the data behind the employee\'s Contact tab — the  EmployeeExtended record (address / emergency contact fields) merged with every  EmployeeContact row (phones / email) — ordered by database timestamp ascending (SPD-5600).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdContactInfoAuditsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdContactInfoAuditsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/contactInfo/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the contact information and role-based permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdContactInfoGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdContactInfoGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/contactInfo`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the contact information for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeContactInfoRequest} [updateEmployeeContactInfoRequest] The update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdContactInfoPut: async (pkEmployeeId: number, updateEmployeeContactInfoRequest?: UpdateEmployeeContactInfoRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdContactInfoPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/contactInfo`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeContactInfoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The employee\'s custom-field values, each with the raw stored string and the typed  projections LegacyApp\'s converters produce. Self-or-manager guarded via the class-level  `RequireSelfOrManager(\"pkEmployeeId\")` filter, then the caller\'s  `EmployeeCustomView` for this employee.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdCustomValuesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdCustomValuesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/custom-values`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Batch write for the employee\'s custom values with LegacyApp\'s employee-form semantics:  singleton/cell upserts, historical-group row adds (one shared key per row set), and  group removals. Values are stored in the exact strings legacy\'s controls write, so the  WinForms app renders web edits untouched.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {UpdateEmployeeCustomValuesRequestV2} [updateEmployeeCustomValuesRequestV2] The batch of writes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdCustomValuesPut: async (pkEmployeeId: number, updateEmployeeCustomValuesRequestV2?: UpdateEmployeeCustomValuesRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdCustomValuesPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/custom-values`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeCustomValuesRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the effective-date UI configuration for the given employee and effective date type.  Equivalent to ta-web\'s `GET /api/Employee/EffectiveDateConfiguration`.
         * @param {number} pkEmployeeId The target employee identifier.
         * @param {EffectiveDateType} [effectiveDateType] Type driving Day One radio-button availability.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet: async (pkEmployeeId: number, effectiveDateType?: EffectiveDateType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/effectiveDateConfiguration`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (effectiveDateType !== undefined) {
                localVarQueryParameter['effectiveDateType'] = effectiveDateType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the employee ID for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeIdRequest} [updateEmployeeIdRequest] The update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmployeeIdPut: async (pkEmployeeId: number, updateEmployeeIdRequest?: UpdateEmployeeIdRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmployeeIdPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employeeId`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee\'s licensing record.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employeeLicense/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the employee status types available for the given employee\'s role.  Mirrors ta-web\'s `GET /api/Employee/{employeeId}/EmployeeStatusTypeList`.  When the role has `EmployeeStatusesNoTerminatedStatusTypes` set, only  `ConsideredHired` types are returned; otherwise all types are returned.
         * @param {number} pkEmployeeId The primary key of the target employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmployeeStatusTypesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmployeeStatusTypesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employeeStatusTypes`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the employment audit records for the specified employee,  ordered by database timestamp ascending.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentAuditsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentAuditsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employment/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-deletes a single in-service row. Replaces TaAPI  `DELETE /api/Employee/{employeeId}/Employment/EmployeeInService/{inServiceId}`.  Returns a boolean (TaAPI parity).
         * @param {number} pkEmployeeId 
         * @param {number} inServiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete: async (pkEmployeeId: number, inServiceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'inServiceId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete', 'inServiceId', inServiceId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employment/employeeInService/{inServiceId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"inServiceId"}}`, encodeURIComponent(String(inServiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee in-service entry,  ordered by database timestamp ascending (SPD-5600).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} employeeInServiceId The employee in-service entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet: async (pkEmployeeId: number, employeeInServiceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'employeeInServiceId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet', 'employeeInServiceId', employeeInServiceId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employment/employeeInServices/{employeeInServiceId}/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"employeeInServiceId"}}`, encodeURIComponent(String(employeeInServiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all in-service records taken by the specified employee,  each with its in-service definition including mandatory and taken flags.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employment/employeeInServices`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns general employment data and permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentGeneralGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentGeneralGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employment/general`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the health record and UI configuration for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentHealthGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentHealthGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employment/health`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the I-9 documents and employment eligibility details for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employment/i9Documents`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the in-service list for the specified employee with mandatory and taken flags.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {string} serviceCategory Category filter: &#x60;All&#x60;, &#x60;Mandatory&#x60; (case-insensitive), or a specific category string ID.
         * @param {string} [serviceGroup] Optional in-service group string ID. When omitted, the employee\&#39;s default group is used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet: async (pkEmployeeId: number, serviceCategory: string, serviceGroup?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'serviceCategory' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet', 'serviceCategory', serviceCategory)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employment/inServiceList/{serviceCategory}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"serviceCategory"}}`, encodeURIComponent(String(serviceCategory)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceGroup !== undefined) {
                localVarQueryParameter['serviceGroup'] = serviceGroup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds one or more in-service records. Replaces TaAPI  `POST /api/Employee/{employeeId}/Employment/InService`. Returns the count of  successfully inserted rows (TaAPI parity — partial success).
         * @param {number} pkEmployeeId 
         * @param {Array<EmployeeInServiceAddRequestV2>} [employeeInServiceAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentInServicePost: async (pkEmployeeId: number, employeeInServiceAddRequestV2?: Array<EmployeeInServiceAddRequestV2>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentInServicePost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employment/inService`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeInServiceAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the licensing information and role-based permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentLicenseGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdEmploymentLicenseGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/employment/license`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the header details for the specified employee. Opening someone in  Employee Center (and creating an employee) records them on the caller\'s  Recently Viewed list (SPD-4205). A recording failure is logged and does not  fail the header response.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHeaderGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHeaderGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/header`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee\'s health record.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHealthAuditsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHealthAuditsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/health/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the history records and role-based permission flags for the specified employee.  Always returns 200 — use `IsEmployeeHistoryGridVisible` to determine view access.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoriesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHistoriesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/histories`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the minimum effective date the add-history modal may use for the given history  type — the caller-role-aware port of TaAPI `POST /api/Employee/minhistorydate`  (ta-legacy `PayPeriodGroup.StartDateOfEarliestOpenPayPeriodForLoggedIn`): the start of  the pay period following the employee\'s latest closed-or-approved period, with the  historical-edit carve-outs (labor levels / accrual group) returning 2001-01-01.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {EmployeeHistoryType} [historyType] The history type the entry will be added under (defaults to &#x60;None&#x60;, the plain pay-period walk).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet: async (pkEmployeeId: number, historyType?: EmployeeHistoryType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/histories/min-effective-date`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (historyType !== undefined) {
                localVarQueryParameter['historyType'] = historyType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a history entry (labor level, pay rule, base schedule group, holiday group, or  accrual group) for the specified employee at an effective date.  Committing port of TaAPI `POST /api/Employee/AddHistoryType`: ta-web only stages the  insert in its session unit of work (committed exclusively by the SaveEmployee flow the web  FE removed), so the row never reaches the tenant DB — this endpoint persists atomically.
         * @param {number} pkEmployeeId The employee identifier (authoritative; a mismatching non-zero body id is rejected).
         * @param {AddEmployeeHistoryTypeRequest} [addEmployeeHistoryTypeRequest] The TaAPI-shaped add-history request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoriesPost: async (pkEmployeeId: number, addEmployeeHistoryTypeRequest?: AddEmployeeHistoryTypeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHistoriesPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/histories`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEmployeeHistoryTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee history entry,  ordered by database timestamp ascending.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} employeeRecordId The employee history entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet: async (pkEmployeeId: number, employeeRecordId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'employeeRecordId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet', 'employeeRecordId', employeeRecordId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/history/{employeeRecordId}/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"employeeRecordId"}}`, encodeURIComponent(String(employeeRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes the specified history entry for the given employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} pkHistoryId The history entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete: async (pkEmployeeId: number, pkHistoryId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'pkHistoryId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete', 'pkHistoryId', pkHistoryId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/history/{pkHistoryId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"pkHistoryId"}}`, encodeURIComponent(String(pkHistoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the available history types and their selectable values for the specified employee.  Each entry contains a history type (e.g., a configured labor level, PayRule, BaseScheduleGroup)  and the values the employee may select from, filtered by facility and role.
         * @param {number} pkEmployeeId The primary key of the target employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoryTypesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHistoryTypesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/historyTypes`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the holiday group for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeHolidayGroupRequest} [updateEmployeeHolidayGroupRequest] The request containing the holiday group information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHolidayGroupPut: async (pkEmployeeId: number, updateEmployeeHolidayGroupRequest?: UpdateEmployeeHolidayGroupRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHolidayGroupPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/holidayGroup`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeHolidayGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all holiday groups accessible to the specified employee,  filtered by the employee\'s facility.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHolidayGroupsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdHolidayGroupsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/holidayGroups`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the journal entries and role-based permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdJournalsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdJournalsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/journals`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee journal entry,  ordered by database timestamp ascending (SPD-5600).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} pkEmployeeJournalId The employee journal entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet: async (pkEmployeeId: number, pkEmployeeJournalId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'pkEmployeeJournalId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet', 'pkEmployeeJournalId', pkEmployeeJournalId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/journals/{pkEmployeeJournalId}/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"pkEmployeeJournalId"}}`, encodeURIComponent(String(pkEmployeeJournalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes the specified employee journal entry.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} pkEmployeeJournalId The employee journal entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete: async (pkEmployeeId: number, pkEmployeeJournalId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'pkEmployeeJournalId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete', 'pkEmployeeJournalId', pkEmployeeJournalId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/journals/{pkEmployeeJournalId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"pkEmployeeJournalId"}}`, encodeURIComponent(String(pkEmployeeJournalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new employee journal entry for the specified employee, based on the provided request data.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {CreateEmployeeJournalRequest} [createEmployeeJournalRequest] The create request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdJournalsPost: async (pkEmployeeId: number, createEmployeeJournalRequest?: CreateEmployeeJournalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdJournalsPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/journals`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmployeeJournalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing employee journal entry for the specified employee, based on the provided request data.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeJournalRequest} [updateEmployeeJournalRequest] The update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdJournalsPut: async (pkEmployeeId: number, updateEmployeeJournalRequest?: UpdateEmployeeJournalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdJournalsPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/journals`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeJournalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the labor levels at the specified index, filtered to those that belong to  the employee\'s facility (multi-facility environments only).  Equivalent to ta-web\'s `GET /api/Employee/{employeeId}/LaborLevel/{level}`.
         * @param {number} pkEmployeeId The employee identifier used to resolve the facility filter.
         * @param {number} level Zero-based labor level index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLaborLevelLevelGet: async (pkEmployeeId: number, level: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdLaborLevelLevelGet', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'level' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdLaborLevelLevelGet', 'level', level)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/laborLevel/{level}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"level"}}`, encodeURIComponent(String(level)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validates and normalizes a proposed set of labor level IDs for an employee without persisting  any changes. Mirrors ta-web `PATCH /api/Employee/EmployeeLaborLevelsCheck`.
         * @param {number} pkEmployeeId Primary key of the employee to validate against.
         * @param {number} [changedLevel] Optional: the labor level level (0-based slot, 0 to 9) the user just changed; it decides when the  PBJ Job Code is pre-filled (SPD-5249, see M:OpenShifts.IServices.Interfaces.EmployeeCenter.IFacilityEmployeeServiceV2.CheckEmployeeLaborLevelsAsync(System.Int64,System.Int64[],System.Nullable{System.Int32},System.Threading.CancellationToken)).  Any other value is a 400.
         * @param {Array<number>} [requestBody] Array of exactly 10 labor level PKs to validate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch: async (pkEmployeeId: number, changedLevel?: number, requestBody?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/laborLevels/check`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (changedLevel !== undefined) {
                localVarQueryParameter['changedLevel'] = changedLevel;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the labor levels for the specified employee with an effective date.  Replaces ta-web `PUT /api/Employee/EmployeeLaborLevels`.  Requires `EmployeeMainEdit` on the caller\'s role.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeLaborLevelsRequest} [updateEmployeeLaborLevelsRequest] The request body containing exactly 10 labor level PKs (one per level 0–9) and the  effective date. Pass &#x60;0&#x60; for any level that should not be updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLaborLevelsPut: async (pkEmployeeId: number, updateEmployeeLaborLevelsRequest?: UpdateEmployeeLaborLevelsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdLaborLevelsPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/laborLevels`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeLaborLevelsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the license types available for the specified employee\'s facility state,  as a dictionary of `LicenseType` integer value to friendly display name.  Always includes `Unknown` and `NotApplicable`, followed by state-specific types.
         * @param {number} pkEmployeeId The primary key of the target employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLicenseTypesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdLicenseTypesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/licenseTypes`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Releases the caller\'s own lock on this employee (navigate away / deselect).
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLockDelete: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdLockDelete', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/lock`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lock-on-view acquire/refresh (SPD-5570). Returns holder info instead of erroring on  conflict.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLockPost: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdLockPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/lock`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Release Current Employee\'s Locks — even others\'; requires legacy  `Role.AllowReleasingOfLock`.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLocksDelete: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdLocksDelete', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/locks`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the narrow projection consumed by the Employee Settings → Main tab. Replaces  the legacy TaAPI `GET /api/Employee/{pkEmployeeId}?doRefreshEmployee=...`: the FE  only binds ~25 of the 100+ fields from the legacy detail dump, so this endpoint returns  just those. SaaSAPI is stateless per request, so the `doRefreshEmployee`  cache-bypass parameter is dropped — every call is fresh.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdMainGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdMainGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/main`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee\'s miscellaneous settings (extended) record.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdMiscAuditsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdMiscAuditsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/misc/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns miscellaneous settings for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdMiscGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdMiscGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/misc`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates miscellaneous settings for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeMiscSettingsRequest} [updateEmployeeMiscSettingsRequest] Fields to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdMiscPut: async (pkEmployeeId: number, updateEmployeeMiscSettingsRequest?: UpdateEmployeeMiscSettingsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdMiscPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/misc`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeMiscSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the pay period group assigned to the employee via their pay rule.
         * @param {number} pkEmployeeId The employee primary key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayPeriodGroupGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayPeriodGroupGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/payPeriodGroup`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee pay rate entry.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} payRateId The employee pay rate identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet: async (pkEmployeeId: number, payRateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'payRateId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet', 'payRateId', payRateId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/payRate/{payRateId}/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"payRateId"}}`, encodeURIComponent(String(payRateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-deletes a single pay-rate row. Replaces TaAPI  `DELETE /api/Employee/{employeeId}/PayRate/{payRateId}`. Returns `true` when  a row was removed, `false` when no matching row existed (TaAPI parity).
         * @param {number} pkEmployeeId 
         * @param {number} payRateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete: async (pkEmployeeId: number, payRateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'payRateId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete', 'payRateId', payRateId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/payRate/{payRateId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"payRateId"}}`, encodeURIComponent(String(payRateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replaces TaAPI `PUT /api/Employee/{employeeId}/PayRate/{payRateId}`. Updates the  `PayTypeId` / `ShiftId` / `Note` on an existing pay-rate row. The route  pkEmployeeId and payRateId overwrite the body\'s  `EmployeeId` and `Id` respectively (TaAPI parity). Requires  `EmployeePayRatesAdd` on the caller\'s role.
         * @param {number} pkEmployeeId 
         * @param {number} payRateId 
         * @param {EmployeePayRateUpdateRequestV2} [employeePayRateUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatePayRateIdPut: async (pkEmployeeId: number, payRateId: number, employeePayRateUpdateRequestV2?: EmployeePayRateUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRatePayRateIdPut', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'payRateId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRatePayRateIdPut', 'payRateId', payRateId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/payRate/{payRateId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"payRateId"}}`, encodeURIComponent(String(payRateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeePayRateUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replaces TaAPI `POST /api/Employee/PayRate`. Adds a new `EmployeePayRate` row;  returns the new PK. Requires `EmployeePayRatesAdd` on the caller\'s role.
         * @param {number} pkEmployeeId 
         * @param {EmployeePayRateAddRequestV2} [employeePayRateAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatePost: async (pkEmployeeId: number, employeePayRateAddRequestV2?: EmployeePayRateAddRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRatePost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/payRate`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeePayRateAddRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the pay rates and role-based permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRatesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/payRates`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns facility-wide pay rate configuration settings and whether the caller  has permission to view pay rates for the specified employee.
         * @param {number} pkEmployeeId The employee identifier used to evaluate role-based auth.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatesSettingsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRatesSettingsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/payRates/settings`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the pay rule for the specified employee with an effective date.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeePayRuleRequest} [updateEmployeePayRuleRequest] The request containing the pay rule information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRulePut: async (pkEmployeeId: number, updateEmployeePayRuleRequest?: UpdateEmployeePayRuleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRulePut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/payRule`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeePayRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all pay rules accessible to the specified employee,  filtered by the employee\'s facility and role-based restrictions.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRulesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayRulesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/payRules`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all pay types accessible to the specified employee,  filtered by facility binding and role-based restrictions.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayTypesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPayTypesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/payTypes`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accessible to managers (FacilityManager, Admin, System, Support) acting on any employee,  and to an authenticated Employee acting on themselves — enforced by OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute.
         * @summary Returns a time-limited SAS URL for the employee\'s profile picture.  The URL validity period is controlled by `ProfilePictureServiceV2.SasExpiry`.  The underlying filename is resolved from an in-memory cache and only falls back  to a database query on a cache miss.
         * @param {number} pkEmployeeId Primary key of the employee in the facility database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdProfilePictureGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdProfilePictureGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/profilePicture`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accessible to managers (FacilityManager, Admin, System, Support) acting on any employee,  and to an authenticated Employee uploading their own picture — enforced by OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute.
         * @summary Uploads a new profile picture for the employee, saves the filename to the facility  database, and refreshes the in-memory cache so subsequent GET requests immediately  reflect the new image.
         * @param {number} pkEmployeeId Primary key of the employee in the facility database.
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdProfilePicturePost: async (pkEmployeeId: number, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdProfilePicturePost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/profilePicture`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('File', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the employee\'s first/middle/last name + tag. Replaces TaAPI  `PUT /api/Employee`. Requires `EmployeeMainEdit` on the caller\'s role.
         * @param {number} pkEmployeeId 
         * @param {EmployeeMainInfoUpdateRequestV2} [employeeMainInfoUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPut: async (pkEmployeeId: number, employeeMainInfoUpdateRequestV2?: EmployeeMainInfoUpdateRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeMainInfoUpdateRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the salaried hours for the specified employee.  The value is stored as minutes in the database and returned as hours (minutes / 60).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdSalariedHoursGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdSalariedHoursGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/salariedHours`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the salaried hours for the specified employee.  The value is stored as minutes in the database (round(hours * 60)).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [body] New salaried hours value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdSalariedHoursPut: async (pkEmployeeId: number, body?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdSalariedHoursPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/salariedHours`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolves the appropriate employee shift type for a candidate shift without persisting.
         * @param {number} pkEmployeeId The employee identifier (overrides the body\&#39;s EmployeeId).
         * @param {AdjustEmployeeShift} [adjustEmployeeShift] The adjustment request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsAdjustmentPost: async (pkEmployeeId: number, adjustEmployeeShift?: AdjustEmployeeShift, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdShiftsAdjustmentPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/shifts/adjustment`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adjustEmployeeShift, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee shift.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [employeeShiftId] The employee shift identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsAuditsGet: async (pkEmployeeId: number, employeeShiftId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdShiftsAuditsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/shifts/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (employeeShiftId !== undefined) {
                localVarQueryParameter['employeeShiftId'] = employeeShiftId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes one or more shifts from the specified employee.
         * @param {number} pkEmployeeId The employee identifier (overrides the body\&#39;s EmployeeId).
         * @param {DeleteEmployeeShift} [deleteEmployeeShift] The delete request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsDelete: async (pkEmployeeId: number, deleteEmployeeShift?: DeleteEmployeeShift, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdShiftsDelete', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/shifts`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteEmployeeShift, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all shifts for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdShiftsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/shifts`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a single shift to the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {EmployeeShiftRequest} [employeeShiftRequest] The shift to add.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsPost: async (pkEmployeeId: number, employeeShiftRequest?: EmployeeShiftRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdShiftsPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/shifts`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeShiftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the shift and/or shift-type assignment of an existing employee shift.
         * @param {number} pkEmployeeId The employee identifier (overrides the body\&#39;s EmployeeId).
         * @param {UpdateEmployeeShift} [updateEmployeeShift] The update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsPut: async (pkEmployeeId: number, updateEmployeeShift?: UpdateEmployeeShift, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdShiftsPut', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/shifts`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeShift, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee status entry.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} employeeStatusId The employee status entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet: async (pkEmployeeId: number, employeeStatusId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'employeeStatusId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet', 'employeeStatusId', employeeStatusId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/status/{employeeStatusId}/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"employeeStatusId"}}`, encodeURIComponent(String(employeeStatusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the statuses and role-based permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdStatusesGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdStatusesGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/statuses`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes the specified employee status entry and its associated comment.  Mirrors ta-web `DELETE /api/Employee/Status`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} pkEmployeeStatusId The status entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete: async (pkEmployeeId: number, pkEmployeeStatusId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'pkEmployeeStatusId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete', 'pkEmployeeStatusId', pkEmployeeStatusId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/statuses/{pkEmployeeStatusId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"pkEmployeeStatusId"}}`, encodeURIComponent(String(pkEmployeeStatusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing employee status entry (hire-date flag, PBJ status type, comment).  Mirrors ta-web `PUT /api/Employee/Status`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} pkEmployeeStatusId The status entry identifier.
         * @param {UpdateEmployeeStatusRequest} [updateEmployeeStatusRequest] The update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut: async (pkEmployeeId: number, pkEmployeeStatusId: number, updateEmployeeStatusRequest?: UpdateEmployeeStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'pkEmployeeStatusId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut', 'pkEmployeeStatusId', pkEmployeeStatusId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/statuses/{pkEmployeeStatusId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"pkEmployeeStatusId"}}`, encodeURIComponent(String(pkEmployeeStatusId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmployeeStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a new status entry for the specified employee.  Mirrors ta-web `POST /api/Employee/AddStatus`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {AddEmployeeStatusRequest} [addEmployeeStatusRequest] The add request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdStatusesPost: async (pkEmployeeId: number, addEmployeeStatusRequest?: AddEmployeeStatusRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdStatusesPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/statuses`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEmployeeStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reverses the caller\'s ENTIRE remaining micro-session undo stack for this employee in one  all-or-nothing operation.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdUndoAllPost: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdUndoAllPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/undo/all`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reverses the most recent remaining action in the caller\'s micro-session undo stack for  this employee.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdUndoPost: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdUndoPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/undo`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ends the caller\'s undo micro-session for this employee view: purges the session\'s whole  stack. Fired by the FE on Profile-tab enter and on leaving the employee center. No lock  required — it can only destroy the caller\'s own history. Idempotent; 204 also when no  micro-session header rides the request.
         * @param {number} pkEmployeeId The primary key identifier of the employee (route symmetry; the purge is session-scoped).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdUndoSessionDelete: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdUndoSessionDelete', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/undo/session`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the caller\'s micro-session undo stack for this employee, newest-first.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdUndoStackGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdUndoStackGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/undo/stack`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the shift and work-pattern UI permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdWorkPatternConfigurationGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdWorkPatternConfigurationGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/workPatternConfiguration`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee work pattern entry.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} workPatternId The employee work pattern identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet: async (pkEmployeeId: number, workPatternId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'workPatternId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet', 'workPatternId', workPatternId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/workPattern/{workPatternId}/audits`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"workPatternId"}}`, encodeURIComponent(String(workPatternId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the work patterns for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdWorkPatternsGet: async (pkEmployeeId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdWorkPatternsGet', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/workPatterns`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a new work pattern entry for the employee.  Mirrors ta-web `POST /api/Employee/{employeeId}/workpattern`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {AddEmployeeWorkPatternRequest} [addEmployeeWorkPatternRequest] Date and type of the new work pattern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdWorkPatternsPost: async (pkEmployeeId: number, addEmployeeWorkPatternRequest?: AddEmployeeWorkPatternRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdWorkPatternsPost', 'pkEmployeeId', pkEmployeeId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/workPatterns`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEmployeeWorkPatternRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validates the requested pay period belongs to the employee and returns the recalculate-button state.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} workingPayPeriodId The pay period identifier to validate and set as working.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch: async (pkEmployeeId: number, workingPayPeriodId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pkEmployeeId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch', 'pkEmployeeId', pkEmployeeId)
            // verify required parameter 'workingPayPeriodId' is not null or undefined
            assertParamExists('apiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch', 'workingPayPeriodId', workingPayPeriodId)
            const localVarPath = `/api/v2/employees/{pkEmployeeId}/workingPayPeriod/{workingPayPeriodId}`
                .replace(`{${"pkEmployeeId"}}`, encodeURIComponent(String(pkEmployeeId)))
                .replace(`{${"workingPayPeriodId"}}`, encodeURIComponent(String(workingPayPeriodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves the authorized employees for the logged-in employee and returns the grouped result set.
         * @param {FindEmployeeRequestV2} [findEmployeeRequestV2] Search, filter, sort, and paging options for the employee query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPost: async (findEmployeeRequestV2?: FindEmployeeRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(findEmployeeRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Landing-page snapshot for Time & Attendance widgets: hours, OT, approaching OT,  punched in, and pending punch requests (missing-punch and time-change notifications  from the app — not absence/PTO). Scoped to employees the caller can view.  Hours dates come from the caller\'s pay-period group for every facility row.  Approaching OT is Hours that count toward period overtime (the pay type\'s  `…CountTowardsPeriodOvertime` flags, as in legacy), summed over each employee\'s own  current overtime period, vs that period\'s threshold (an employee with no period-OT rule is  left out, as legacy\'s 99999 \"never approaching\" does), for employees whose Hours the caller may  view. The pay periods are the ones containing today, not legacy\'s working and previous periods.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesTaDashboardGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/ta-dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Soft-deletes one or more `EmployeeWorkPattern` rows. Replaces TaAPI  `DELETE /api/Employee/workpattern`. Returns 204 No Content on success.
         * @param {DeleteEmployeeWorkPatternRequestV2} [deleteEmployeeWorkPatternRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesWorkPatternDelete: async (deleteEmployeeWorkPatternRequestV2?: DeleteEmployeeWorkPatternRequestV2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/employees/workPattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteEmployeeWorkPatternRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeV2Api - functional programming interface
 * @export
 */
export const EmployeeV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * The sibling of `checkDuplicateId`, with the same role-only authorization and the same  accepted risk: an existence probe on a non-secret, human-typed ID. It names no one. Create names  the holder when it refuses, but only after the caller\'s role at the new employee\'s labor levels  allows adding an employee with a clock ID; this call checks the JWT role alone. The answer is  the rule creation and the Clock Info tab\'s add enforce, so a free ID here is one the create call  will accept (in multi-facility mode per facility: HandPunch and Accuface route a row by its  holder\'s facility and send an all-clocks employee everywhere, so it does not rule out the same  ID under another facility). Call it while the Clock ID is typed. On submit, call create: it  refuses a taken ID with the holder\'s name and what to do, which this call cannot show.
         * @summary SPD-5664: returns whether a clock ID is already used by another employee, so the Add Employee  form can warn while the ID is typed instead of after the employee is saved.
         * @param {number} [clockId] The clock ID to check; 0 or omitted answers 400.
         * @param {number} [facilityId] The facility the employee will be created under, the Facility selector\&#39;s value the create  request carries as &#x60;facilityId&#x60; (the same facility labor level ID &#x60;checkDuplicateId&#x60;  takes); required in multi-facility mode, null or omitted otherwise.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesCheckDuplicateClockIdGet(clockId?: number, facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClockIdDuplicateCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesCheckDuplicateClockIdGet(clockId, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Authorization is role-only (the `[Authorize(Roles = ...)]` below) — unlike the create  path\'s `CheckLaborLevelAuthorizationAsync`, nothing here verifies the caller has any standing  at facilityId itself. A FacilityManager (or Support/Admin/System) token  scoped to one facility can pass a different facilityId and probe  employee-ID existence there, and in single-facility mode an omitted facilityId  answers tenant-wide. Accepted deliberately, matching `nextAvailableId`\'s existing,  already-shipped shape (SPD-5697 review) — this is an existence probe on a non-secret,  human-typed ID, not a data read, and tightening it would mean duplicating the labor-level  authorization engine on a read endpoint. Revisit if that calculus changes.
         * @summary Returns whether the given employee ID is already in use within a facility.
         * @param {string} [employeeId] The employee ID to check.
         * @param {number} [facilityId] Required in multi-facility mode; pass null or omit for single-facility. This is the labor  level ID for the employee\&#39;s Facility labor level (the same value used to populate the  \&quot;Facility\&quot; selector on the employee create/edit form) — not the SaaS tenant\&#39;s facility GUID  or any other facility identifier. A value from the wrong ID space is rejected with 400  rather than silently scoping to a facility that doesn\&#39;t exist.
         * @param {number} [excludePkEmployeeId] Pass the employee\&#39;s own PkEmployeeId when pre-checking a rename on the edit-employee-ID  field, so their own current ID isn\&#39;t reported as a duplicate of itself. Omit when  pre-checking a new employee\&#39;s ID at creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesCheckDuplicateIdGet(employeeId?: string, facilityId?: number, excludePkEmployeeId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeIdDuplicateCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesCheckDuplicateIdGet(employeeId, facilityId, excludePkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns clock-info permission flags for the logged-in user given exactly 10 labor-level IDs.  Mirrors ta-web `POST /api/Employee/AddClockPermission`.
         * @param {Array<number>} [requestBody] An array of exactly 10 labor level PKs corresponding to the clock ID\&#39;s labor level slots.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesClockInfoPermissionsPost(requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddClockPermissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesClockInfoPermissionsPost(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates a new employee (heaviest write-side port of TaAPI `EmployeeController.CreateEmployee`).
         * @param {CreateEmployeeRequest} [createEmployeeRequest] The create-employee request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesCreatePost(createEmployeeRequest?: CreateEmployeeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEmployeeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesCreatePost(createEmployeeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary The facility\'s custom-tab definitions: tabs, fields and dropdown options. Carries no  employee id, so the class-level `RequireSelfOrManager` filter no-ops here and the  caller\'s own `EmployeeCustomView` is the gate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesCustomTabsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCustomTabsResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesCustomTabsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the Licensing tab. Replaces TaAPI  `PUT /api/Employee/Employment/EmployeeLicense`. Returns the hydrated  OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeLicenseResponse.
         * @param {EmployeeLicenseUpdateRequestV2} [employeeLicenseUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesEmploymentEmployeeLicensePut(employeeLicenseUpdateRequestV2?: EmployeeLicenseUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeLicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesEmploymentEmployeeLicensePut(employeeLicenseUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the General employment tab. Replaces TaAPI  `PUT /api/Employee/Employment/General`. Returns `true` on success.
         * @param {EmployeeEmploymentGeneralUpdateRequestV2} [employeeEmploymentGeneralUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesEmploymentGeneralPut(employeeEmploymentGeneralUpdateRequestV2?: EmployeeEmploymentGeneralUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesEmploymentGeneralPut(employeeEmploymentGeneralUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the Health tab. Replaces TaAPI `PUT /api/Employee/Employment/Health`.  Returns the hydrated OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeHealthResponse.
         * @param {EmployeeHealthUpdateRequestV2} [employeeHealthUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesEmploymentHealthPut(employeeHealthUpdateRequestV2?: EmployeeHealthUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeHealthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesEmploymentHealthPut(employeeHealthUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the I-9 Documents tab. Replaces TaAPI  `PUT /api/Employee/Employment/I9Documents`. Returns the hydrated  OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeI9DocumentsResponse.
         * @param {EmployeeI9DocumentsUpdateRequestV2} [employeeI9DocumentsUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesEmploymentI9DocumentsPut(employeeI9DocumentsUpdateRequestV2?: EmployeeI9DocumentsUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeI9DocumentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesEmploymentI9DocumentsPut(employeeI9DocumentsUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the authorized employee groups for the current employee based on the provided grouping and filter request.
         * @param {FindEmployeeGroupRequest} [findEmployeeGroupRequest] The employee group search and filter request. When the request body is null, an empty request is used  to keep the endpoint behavior stable and avoid null-reference issues.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesGroupsPost(findEmployeeGroupRequest?: FindEmployeeGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeGroupsPageResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesGroupsPost(findEmployeeGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the labor levels for the given filter type used for employee filtering.  Replaces ta-web\'s `GET /api/Employee/BudgetGroupLaborLevelsForFilter` and  `GET /api/Employee/DepartmentLaborLevelsForFilter`.
         * @param {LaborLevelFilterType} type Which configured labor level index to resolve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesLaborLevelsForFilterTypeGet(type: LaborLevelFilterType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LaborLevelResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesLaborLevelsForFilterTypeGet(type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Release All Locks — every lock, every owner. Gated on the caller\'s legacy TA role being  the Administrator built-in (`Role.IsAdministrator`), matching LegacyApp, which only  shows this command when `role.IsAdministrator` (MainFormRibbonSetup.cs:136-137). The  check runs in the service; an identity-role restriction here would 403 every facility  caller, because `UserRoles.Admin` is a SaaS platform role facility users never carry  (SPD-5803).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesLocksDelete(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesLocksDelete(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Release My Locks — all of the caller\'s locks, all sessions (legacy built-in).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesLocksMineDelete(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesLocksMineDelete(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns identity and role-flag details for the currently authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesMeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoggedInUserDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesMeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the signed-in employee\'s own personal info (emergency contact, home address, email,  home phone) for the mobile / self-service surface.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesMePersonalInfoGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeePersonalInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesMePersonalInfoGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Self-service update of the authenticated employee\'s own personal info — address, emergency  contact, email and home phone. The caller is resolved from the JWT (mobile `me` route),  and the mobile client wraps its payload in a `body` envelope. Ports the mobile contact  update that had no V2 equivalent (SPD-5482).
         * @param {UpdatePersonalInfoRequestV2} [updatePersonalInfoRequestV2] The personal-info update, wrapped in a &#x60;body&#x60; envelope.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesMePersonalInfoPut(updatePersonalInfoRequestV2?: UpdatePersonalInfoRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesMePersonalInfoPut(updatePersonalInfoRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Authorization is role-only — nothing verifies the caller has any standing at  facilityId itself. Same accepted-risk decision as `checkDuplicateId`  (SPD-5697 review): an existence probe on a non-secret, human-typed ID, not a data read.
         * @summary Returns the next available employee ID within a facility.
         * @param {number} [facilityId] Facility to scope the search. Required in multi-facility mode; pass null or omit for single-facility.
         * @param {number} [startingFrom] When provided, returns the smallest integer ≥ this value not already in use.  When null, returns max existing numeric ID + 1.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesNextAvailableIdGet(facilityId?: number, startingFrom?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NextAvailableEmployeeIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesNextAvailableIdGet(facilityId, startingFrom, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the accrual group for the specified employee with an effective date.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeAccrualGroupRequest} [updateEmployeeAccrualGroupRequest] The request containing the accrual group information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAccrualGroupPut(pkEmployeeId: number, updateEmployeeAccrualGroupRequest?: UpdateEmployeeAccrualGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAccrualGroupPut(pkEmployeeId, updateEmployeeAccrualGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all accrual groups accessible to the specified employee,  filtered by the employee\'s facility.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAccrualGroupsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccrualGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAccrualGroupsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The returned labor levels are filtered based on the employee\'s facility.  This endpoint always returns HTTP 200 with a consistent response shape.  Caching must be scoped per authenticated user and employee.
         * @summary Returns all labor levels available to the specified employee,  grouped by labor level index.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAllLaborLevelsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<LaborLevelResponseBase>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAllLaborLevelsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the Employee entity itself,  ordered by database timestamp ascending.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuditsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuditsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the data behind the employee\'s Authorizations tab — the  EmployeeAuthorization record merged with every EmployeeAuthorizationLaborLevel row —  ordered by database timestamp ascending (SPD-5600).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuthorizationAuditsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuthorizationAuditsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Disables (soft-deletes) the authorization for the specified employee. Mirrors TaAPI  `DELETE {employeeId}/Authorization`.
         * @param {number} pkEmployeeId The employee whose authorization is removed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuthorizationDelete(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuthorizationDelete(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns authorization settings and role-based permission flags for the specified employee.  When the caller\'s role lacks view permission, returns 200 with  `IsAuthorizationTabVisible = false` and all other fields at defaults.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuthorizationGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeAuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuthorizationGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Clones an existing labor-level row on the employee\'s authorization into a new row.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} authorizationLaborLevelId The source row identifier to clone.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost(pkEmployeeId: number, authorizationLaborLevelId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeAuthorizationLaborLevelItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost(pkEmployeeId, authorizationLaborLevelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-deletes a labor-level row from the employee\'s authorization.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} laborLevelId The authorization labor-level row identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete(pkEmployeeId: number, laborLevelId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete(pkEmployeeId, laborLevelId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates a labor-level row on the employee\'s authorization. `EmployeeId` and  `AuthorizationLaborLevelId` are taken from the route, overriding the body.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} laborLevelId The authorization labor-level row identifier.
         * @param {UpdateEmployeeAuthorizationLaborLevelRequest} [updateEmployeeAuthorizationLaborLevelRequest] The update request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut(pkEmployeeId: number, laborLevelId: number, updateEmployeeAuthorizationLaborLevelRequest?: UpdateEmployeeAuthorizationLaborLevelRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeAuthorizationLaborLevelItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut(pkEmployeeId, laborLevelId, updateEmployeeAuthorizationLaborLevelRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a new labor-level row to the employee\'s authorization. `EmployeeId` is taken  from the route, overriding the body.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {AddEmployeeAuthorizationLaborLevelRequest} [addEmployeeAuthorizationLaborLevelRequest] The add request body.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost(pkEmployeeId: number, addEmployeeAuthorizationLaborLevelRequest?: AddEmployeeAuthorizationLaborLevelRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeAuthorizationLaborLevelItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost(pkEmployeeId, addEmployeeAuthorizationLaborLevelRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Enables authorization for the specified employee (creates an authorization record with  generated defaults). Mirrors TaAPI `POST {employeeId}/Authorization`.
         * @param {number} pkEmployeeId The employee to enable authorization for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuthorizationPost(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeAuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuthorizationPost(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the authorization details for the specified employee. Mirrors TaAPI  `PUT {employeeId}/Authorization`: the route employee ID overwrites the body\'s.
         * @param {number} pkEmployeeId The employee whose authorization is updated.
         * @param {UpdateEmployeeAuthorizationRequest} [updateEmployeeAuthorizationRequest] The update payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuthorizationPut(pkEmployeeId: number, updateEmployeeAuthorizationRequest?: UpdateEmployeeAuthorizationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeAuthorizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuthorizationPut(pkEmployeeId, updateEmployeeAuthorizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the role IDs available for the employee authorization combobox.  Always includes \"No Authorization (Built In)\"; includes \"Administrator (Built In)\"  only when the caller is an administrator.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdAuthorizationRolesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdAuthorizationRolesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the base schedule group for the specified employee with an effective date.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeBaseScheduleGroupRequest} [updateEmployeeBaseScheduleGroupRequest] The request containing the base schedule group information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdBaseScheduleGroupPut(pkEmployeeId: number, updateEmployeeBaseScheduleGroupRequest?: UpdateEmployeeBaseScheduleGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdBaseScheduleGroupPut(pkEmployeeId, updateEmployeeBaseScheduleGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all base schedule groups accessible to the specified employee,  filtered by the employee\'s facility.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdBaseScheduleGroupsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseScheduleGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdBaseScheduleGroupsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Assigns or unassigns all facility-matched time clocks to/from the clock ID at the given index  by toggling the `AssignAllTimeClocks` flag and clearing all individual assignment rows.  Mirrors ta-web `PATCH /api/Employee/EmployeeClockInfo/AssignmentAll`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [index] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {SetEmployeeClockInfoAllAssignmentsRequest} [setEmployeeClockInfoAllAssignmentsRequest] Whether to assign or unassign all clocks.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch(pkEmployeeId: number, index?: number, setEmployeeClockInfoAllAssignmentsRequest?: SetEmployeeClockInfoAllAssignmentsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeClockInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch(pkEmployeeId, index, setEmployeeClockInfoAllAssignmentsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Assigns or unassigns a single time clock to/from the clock ID at the given index.  Mirrors ta-web `PATCH /api/Employee/EmployeeClockInfo/Assignment`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [index] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {SetEmployeeClockInfoAssignmentsRequest} [setEmployeeClockInfoAssignmentsRequest] The time clock PK and whether it should be assigned or unassigned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch(pkEmployeeId: number, index?: number, setEmployeeClockInfoAssignmentsRequest?: SetEmployeeClockInfoAssignmentsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch(pkEmployeeId, index, setEmployeeClockInfoAssignmentsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee clock info entry.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} clockIndex The zero-based index of the clock info entry.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet(pkEmployeeId: number, clockIndex: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet(pkEmployeeId, clockIndex, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the time clocks accessible to the specified employee based on facility matching.  An inactive clock, or one of an inactive group, is listed only while it is explicitly  assigned, flagged `isInactive` (SPD-6024).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FacilityTimeClockResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns clock ID info for the specified employee at the given index.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [index] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdClockInfoGet(pkEmployeeId: number, index?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeClockInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdClockInfoGet(pkEmployeeId, index, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the labor level IDs stored on the clock ID at the given index for an employee.  Requires `AllowMultipleClockIDs` to be enabled.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [index] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet(pkEmployeeId: number, index?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet(pkEmployeeId, index, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Writes the 10-element labor level FK array onto the clock ID at the given index.  Mirrors ta-web `PUT /api/Employee/EmployeeClockInfo/LaborLevels`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [index] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {Array<number>} [requestBody] Exactly 10 labor level PKs. Position i maps to &#x60;FkLaborLevel{i}Id&#x60;. Pass 0 to clear a slot.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut(pkEmployeeId: number, index?: number, requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut(pkEmployeeId, index, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lists every clock ID belonging to the specified employee, in the order the clock-scoped  endpoints index them.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdClockInfoListGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeClockInfoListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdClockInfoListGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a new clock ID record for the specified employee.  Mirrors ta-web `POST /api/Employee/EmployeeClockInfo`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {AddEmployeeClockInfoRequest} [addEmployeeClockInfoRequest] The add request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdClockInfoPost(pkEmployeeId: number, addEmployeeClockInfoRequest?: AddEmployeeClockInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeClockInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdClockInfoPost(pkEmployeeId, addEmployeeClockInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates an existing clock ID record for the specified employee.  Mirrors ta-web `PUT /api/Employee/EmployeeClockInfo`.  Only non-null request fields are applied (patch semantics).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [clockIndex] Zero-based clock ID index ordered by PK. Defaults to 0.
         * @param {UpdateEmployeeClockInfoRequest} [updateEmployeeClockInfoRequest] The partial update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdClockInfoPut(pkEmployeeId: number, clockIndex?: number, updateEmployeeClockInfoRequest?: UpdateEmployeeClockInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeClockInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdClockInfoPut(pkEmployeeId, clockIndex, updateEmployeeClockInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the data behind the employee\'s Contact tab — the  EmployeeExtended record (address / emergency contact fields) merged with every  EmployeeContact row (phones / email) — ordered by database timestamp ascending (SPD-5600).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdContactInfoAuditsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdContactInfoAuditsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the contact information and role-based permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdContactInfoGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeContactInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdContactInfoGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the contact information for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeContactInfoRequest} [updateEmployeeContactInfoRequest] The update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdContactInfoPut(pkEmployeeId: number, updateEmployeeContactInfoRequest?: UpdateEmployeeContactInfoRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdContactInfoPut(pkEmployeeId, updateEmployeeContactInfoRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary The employee\'s custom-field values, each with the raw stored string and the typed  projections LegacyApp\'s converters produce. Self-or-manager guarded via the class-level  `RequireSelfOrManager(\"pkEmployeeId\")` filter, then the caller\'s  `EmployeeCustomView` for this employee.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdCustomValuesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCustomValuesResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdCustomValuesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Batch write for the employee\'s custom values with LegacyApp\'s employee-form semantics:  singleton/cell upserts, historical-group row adds (one shared key per row set), and  group removals. Values are stored in the exact strings legacy\'s controls write, so the  WinForms app renders web edits untouched.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {UpdateEmployeeCustomValuesRequestV2} [updateEmployeeCustomValuesRequestV2] The batch of writes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdCustomValuesPut(pkEmployeeId: number, updateEmployeeCustomValuesRequestV2?: UpdateEmployeeCustomValuesRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeCustomValuesResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdCustomValuesPut(pkEmployeeId, updateEmployeeCustomValuesRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the effective-date UI configuration for the given employee and effective date type.  Equivalent to ta-web\'s `GET /api/Employee/EffectiveDateConfiguration`.
         * @param {number} pkEmployeeId The target employee identifier.
         * @param {EffectiveDateType} [effectiveDateType] Type driving Day One radio-button availability.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet(pkEmployeeId: number, effectiveDateType?: EffectiveDateType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectiveDateConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet(pkEmployeeId, effectiveDateType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the employee ID for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeIdRequest} [updateEmployeeIdRequest] The update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmployeeIdPut(pkEmployeeId: number, updateEmployeeIdRequest?: UpdateEmployeeIdRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmployeeIdPut(pkEmployeeId, updateEmployeeIdRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee\'s licensing record.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the employee status types available for the given employee\'s role.  Mirrors ta-web\'s `GET /api/Employee/{employeeId}/EmployeeStatusTypeList`.  When the role has `EmployeeStatusesNoTerminatedStatusTypes` set, only  `ConsideredHired` types are returned; otherwise all types are returned.
         * @param {number} pkEmployeeId The primary key of the target employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmployeeStatusTypesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OpenShiftsBusinessObjectsResponseEmployeeCenterEmployeeStatusTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmployeeStatusTypesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the employment audit records for the specified employee,  ordered by database timestamp ascending.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmploymentAuditsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmploymentAuditsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-deletes a single in-service row. Replaces TaAPI  `DELETE /api/Employee/{employeeId}/Employment/EmployeeInService/{inServiceId}`.  Returns a boolean (TaAPI parity).
         * @param {number} pkEmployeeId 
         * @param {number} inServiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete(pkEmployeeId: number, inServiceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete(pkEmployeeId, inServiceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee in-service entry,  ordered by database timestamp ascending (SPD-5600).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} employeeInServiceId The employee in-service entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet(pkEmployeeId: number, employeeInServiceId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet(pkEmployeeId, employeeInServiceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all in-service records taken by the specified employee,  each with its in-service definition including mandatory and taken flags.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeInServiceItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns general employment data and permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmploymentGeneralGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeEmploymentGeneralResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmploymentGeneralGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the health record and UI configuration for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmploymentHealthGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeHealthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmploymentHealthGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the I-9 documents and employment eligibility details for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeI9DocumentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the in-service list for the specified employee with mandatory and taken flags.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {string} serviceCategory Category filter: &#x60;All&#x60;, &#x60;Mandatory&#x60; (case-insensitive), or a specific category string ID.
         * @param {string} [serviceGroup] Optional in-service group string ID. When omitted, the employee\&#39;s default group is used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet(pkEmployeeId: number, serviceCategory: string, serviceGroup?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InServiceListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet(pkEmployeeId, serviceCategory, serviceGroup, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds one or more in-service records. Replaces TaAPI  `POST /api/Employee/{employeeId}/Employment/InService`. Returns the count of  successfully inserted rows (TaAPI parity — partial success).
         * @param {number} pkEmployeeId 
         * @param {Array<EmployeeInServiceAddRequestV2>} [employeeInServiceAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmploymentInServicePost(pkEmployeeId: number, employeeInServiceAddRequestV2?: Array<EmployeeInServiceAddRequestV2>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmploymentInServicePost(pkEmployeeId, employeeInServiceAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the licensing information and role-based permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdEmploymentLicenseGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeLicenseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdEmploymentLicenseGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves the header details for the specified employee. Opening someone in  Employee Center (and creating an employee) records them on the caller\'s  Recently Viewed list (SPD-4205). A recording failure is logged and does not  fail the header response.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdHeaderGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeHeaderDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdHeaderGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee\'s health record.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdHealthAuditsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdHealthAuditsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the history records and role-based permission flags for the specified employee.  Always returns 200 — use `IsEmployeeHistoryGridVisible` to determine view access.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdHistoriesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdHistoriesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the minimum effective date the add-history modal may use for the given history  type — the caller-role-aware port of TaAPI `POST /api/Employee/minhistorydate`  (ta-legacy `PayPeriodGroup.StartDateOfEarliestOpenPayPeriodForLoggedIn`): the start of  the pay period following the employee\'s latest closed-or-approved period, with the  historical-edit carve-outs (labor levels / accrual group) returning 2001-01-01.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {EmployeeHistoryType} [historyType] The history type the entry will be added under (defaults to &#x60;None&#x60;, the plain pay-period walk).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet(pkEmployeeId: number, historyType?: EmployeeHistoryType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet(pkEmployeeId, historyType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a history entry (labor level, pay rule, base schedule group, holiday group, or  accrual group) for the specified employee at an effective date.  Committing port of TaAPI `POST /api/Employee/AddHistoryType`: ta-web only stages the  insert in its session unit of work (committed exclusively by the SaveEmployee flow the web  FE removed), so the row never reaches the tenant DB — this endpoint persists atomically.
         * @param {number} pkEmployeeId The employee identifier (authoritative; a mismatching non-zero body id is rejected).
         * @param {AddEmployeeHistoryTypeRequest} [addEmployeeHistoryTypeRequest] The TaAPI-shaped add-history request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdHistoriesPost(pkEmployeeId: number, addEmployeeHistoryTypeRequest?: AddEmployeeHistoryTypeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdHistoriesPost(pkEmployeeId, addEmployeeHistoryTypeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee history entry,  ordered by database timestamp ascending.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} employeeRecordId The employee history entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet(pkEmployeeId: number, employeeRecordId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet(pkEmployeeId, employeeRecordId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes the specified history entry for the given employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} pkHistoryId The history entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete(pkEmployeeId: number, pkHistoryId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete(pkEmployeeId, pkHistoryId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the available history types and their selectable values for the specified employee.  Each entry contains a history type (e.g., a configured labor level, PayRule, BaseScheduleGroup)  and the values the employee may select from, filtered by facility and role.
         * @param {number} pkEmployeeId The primary key of the target employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdHistoryTypesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeHistoryTypeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdHistoryTypesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the holiday group for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeHolidayGroupRequest} [updateEmployeeHolidayGroupRequest] The request containing the holiday group information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdHolidayGroupPut(pkEmployeeId: number, updateEmployeeHolidayGroupRequest?: UpdateEmployeeHolidayGroupRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdHolidayGroupPut(pkEmployeeId, updateEmployeeHolidayGroupRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all holiday groups accessible to the specified employee,  filtered by the employee\'s facility.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdHolidayGroupsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HolidayGroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdHolidayGroupsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the journal entries and role-based permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdJournalsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeJournalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdJournalsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee journal entry,  ordered by database timestamp ascending (SPD-5600).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} pkEmployeeJournalId The employee journal entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet(pkEmployeeId: number, pkEmployeeJournalId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet(pkEmployeeId, pkEmployeeJournalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes the specified employee journal entry.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} pkEmployeeJournalId The employee journal entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete(pkEmployeeId: number, pkEmployeeJournalId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete(pkEmployeeId, pkEmployeeJournalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates a new employee journal entry for the specified employee, based on the provided request data.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {CreateEmployeeJournalRequest} [createEmployeeJournalRequest] The create request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdJournalsPost(pkEmployeeId: number, createEmployeeJournalRequest?: CreateEmployeeJournalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeJournalItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdJournalsPost(pkEmployeeId, createEmployeeJournalRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates an existing employee journal entry for the specified employee, based on the provided request data.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeJournalRequest} [updateEmployeeJournalRequest] The update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdJournalsPut(pkEmployeeId: number, updateEmployeeJournalRequest?: UpdateEmployeeJournalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeJournalItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdJournalsPut(pkEmployeeId, updateEmployeeJournalRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the labor levels at the specified index, filtered to those that belong to  the employee\'s facility (multi-facility environments only).  Equivalent to ta-web\'s `GET /api/Employee/{employeeId}/LaborLevel/{level}`.
         * @param {number} pkEmployeeId The employee identifier used to resolve the facility filter.
         * @param {number} level Zero-based labor level index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdLaborLevelLevelGet(pkEmployeeId: number, level: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LaborLevelResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdLaborLevelLevelGet(pkEmployeeId, level, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validates and normalizes a proposed set of labor level IDs for an employee without persisting  any changes. Mirrors ta-web `PATCH /api/Employee/EmployeeLaborLevelsCheck`.
         * @param {number} pkEmployeeId Primary key of the employee to validate against.
         * @param {number} [changedLevel] Optional: the labor level level (0-based slot, 0 to 9) the user just changed; it decides when the  PBJ Job Code is pre-filled (SPD-5249, see M:OpenShifts.IServices.Interfaces.EmployeeCenter.IFacilityEmployeeServiceV2.CheckEmployeeLaborLevelsAsync(System.Int64,System.Int64[],System.Nullable{System.Int32},System.Threading.CancellationToken)).  Any other value is a 400.
         * @param {Array<number>} [requestBody] Array of exactly 10 labor level PKs to validate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch(pkEmployeeId: number, changedLevel?: number, requestBody?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch(pkEmployeeId, changedLevel, requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the labor levels for the specified employee with an effective date.  Replaces ta-web `PUT /api/Employee/EmployeeLaborLevels`.  Requires `EmployeeMainEdit` on the caller\'s role.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeLaborLevelsRequest} [updateEmployeeLaborLevelsRequest] The request body containing exactly 10 labor level PKs (one per level 0–9) and the  effective date. Pass &#x60;0&#x60; for any level that should not be updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdLaborLevelsPut(pkEmployeeId: number, updateEmployeeLaborLevelsRequest?: UpdateEmployeeLaborLevelsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdLaborLevelsPut(pkEmployeeId, updateEmployeeLaborLevelsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the license types available for the specified employee\'s facility state,  as a dictionary of `LicenseType` integer value to friendly display name.  Always includes `Unknown` and `NotApplicable`, followed by state-specific types.
         * @param {number} pkEmployeeId The primary key of the target employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdLicenseTypesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdLicenseTypesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Releases the caller\'s own lock on this employee (navigate away / deselect).
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdLockDelete(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdLockDelete(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lock-on-view acquire/refresh (SPD-5570). Returns holder info instead of erroring on  conflict.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdLockPost(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeLockStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdLockPost(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Release Current Employee\'s Locks — even others\'; requires legacy  `Role.AllowReleasingOfLock`.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdLocksDelete(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdLocksDelete(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the narrow projection consumed by the Employee Settings → Main tab. Replaces  the legacy TaAPI `GET /api/Employee/{pkEmployeeId}?doRefreshEmployee=...`: the FE  only binds ~25 of the 100+ fields from the legacy detail dump, so this endpoint returns  just those. SaaSAPI is stateless per request, so the `doRefreshEmployee`  cache-bypass parameter is dropped — every call is fresh.
         * @param {number} pkEmployeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdMainGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeMainTabResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdMainGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee\'s miscellaneous settings (extended) record.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdMiscAuditsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdMiscAuditsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns miscellaneous settings for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdMiscGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeMiscSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdMiscGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates miscellaneous settings for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeeMiscSettingsRequest} [updateEmployeeMiscSettingsRequest] Fields to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdMiscPut(pkEmployeeId: number, updateEmployeeMiscSettingsRequest?: UpdateEmployeeMiscSettingsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdMiscPut(pkEmployeeId, updateEmployeeMiscSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the pay period group assigned to the employee via their pay rule.
         * @param {number} pkEmployeeId The employee primary key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPayPeriodGroupGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayPeriodGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPayPeriodGroupGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee pay rate entry.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} payRateId The employee pay rate identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet(pkEmployeeId: number, payRateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet(pkEmployeeId, payRateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-deletes a single pay-rate row. Replaces TaAPI  `DELETE /api/Employee/{employeeId}/PayRate/{payRateId}`. Returns `true` when  a row was removed, `false` when no matching row existed (TaAPI parity).
         * @param {number} pkEmployeeId 
         * @param {number} payRateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete(pkEmployeeId: number, payRateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete(pkEmployeeId, payRateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replaces TaAPI `PUT /api/Employee/{employeeId}/PayRate/{payRateId}`. Updates the  `PayTypeId` / `ShiftId` / `Note` on an existing pay-rate row. The route  pkEmployeeId and payRateId overwrite the body\'s  `EmployeeId` and `Id` respectively (TaAPI parity). Requires  `EmployeePayRatesAdd` on the caller\'s role.
         * @param {number} pkEmployeeId 
         * @param {number} payRateId 
         * @param {EmployeePayRateUpdateRequestV2} [employeePayRateUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPayRatePayRateIdPut(pkEmployeeId: number, payRateId: number, employeePayRateUpdateRequestV2?: EmployeePayRateUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPayRatePayRateIdPut(pkEmployeeId, payRateId, employeePayRateUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replaces TaAPI `POST /api/Employee/PayRate`. Adds a new `EmployeePayRate` row;  returns the new PK. Requires `EmployeePayRatesAdd` on the caller\'s role.
         * @param {number} pkEmployeeId 
         * @param {EmployeePayRateAddRequestV2} [employeePayRateAddRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPayRatePost(pkEmployeeId: number, employeePayRateAddRequestV2?: EmployeePayRateAddRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPayRatePost(pkEmployeeId, employeePayRateAddRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the pay rates and role-based permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPayRatesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeePayRatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPayRatesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns facility-wide pay rate configuration settings and whether the caller  has permission to view pay rates for the specified employee.
         * @param {number} pkEmployeeId The employee identifier used to evaluate role-based auth.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPayRatesSettingsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PayRateSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPayRatesSettingsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the pay rule for the specified employee with an effective date.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {UpdateEmployeePayRuleRequest} [updateEmployeePayRuleRequest] The request containing the pay rule information.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPayRulePut(pkEmployeeId: number, updateEmployeePayRuleRequest?: UpdateEmployeePayRuleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPayRulePut(pkEmployeeId, updateEmployeePayRuleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all pay rules accessible to the specified employee,  filtered by the employee\'s facility and role-based restrictions.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPayRulesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayRuleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPayRulesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all pay types accessible to the specified employee,  filtered by facility binding and role-based restrictions.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPayTypesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PayTypeEntityResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPayTypesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Accessible to managers (FacilityManager, Admin, System, Support) acting on any employee,  and to an authenticated Employee acting on themselves — enforced by OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute.
         * @summary Returns a time-limited SAS URL for the employee\'s profile picture.  The URL validity period is controlled by `ProfilePictureServiceV2.SasExpiry`.  The underlying filename is resolved from an in-memory cache and only falls back  to a database query on a cache miss.
         * @param {number} pkEmployeeId Primary key of the employee in the facility database.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdProfilePictureGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfilePictureUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdProfilePictureGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Accessible to managers (FacilityManager, Admin, System, Support) acting on any employee,  and to an authenticated Employee uploading their own picture — enforced by OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute.
         * @summary Uploads a new profile picture for the employee, saves the filename to the facility  database, and refreshes the in-memory cache so subsequent GET requests immediately  reflect the new image.
         * @param {number} pkEmployeeId Primary key of the employee in the facility database.
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdProfilePicturePost(pkEmployeeId: number, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfilePictureUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdProfilePicturePost(pkEmployeeId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the employee\'s first/middle/last name + tag. Replaces TaAPI  `PUT /api/Employee`. Requires `EmployeeMainEdit` on the caller\'s role.
         * @param {number} pkEmployeeId 
         * @param {EmployeeMainInfoUpdateRequestV2} [employeeMainInfoUpdateRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdPut(pkEmployeeId: number, employeeMainInfoUpdateRequestV2?: EmployeeMainInfoUpdateRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdPut(pkEmployeeId, employeeMainInfoUpdateRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the salaried hours for the specified employee.  The value is stored as minutes in the database and returned as hours (minutes / 60).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdSalariedHoursGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdSalariedHoursGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the salaried hours for the specified employee.  The value is stored as minutes in the database (round(hours * 60)).
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [body] New salaried hours value.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdSalariedHoursPut(pkEmployeeId: number, body?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdSalariedHoursPut(pkEmployeeId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resolves the appropriate employee shift type for a candidate shift without persisting.
         * @param {number} pkEmployeeId The employee identifier (overrides the body\&#39;s EmployeeId).
         * @param {AdjustEmployeeShift} [adjustEmployeeShift] The adjustment request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdShiftsAdjustmentPost(pkEmployeeId: number, adjustEmployeeShift?: AdjustEmployeeShift, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdShiftsAdjustmentPost(pkEmployeeId, adjustEmployeeShift, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee shift.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} [employeeShiftId] The employee shift identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdShiftsAuditsGet(pkEmployeeId: number, employeeShiftId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdShiftsAuditsGet(pkEmployeeId, employeeShiftId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes one or more shifts from the specified employee.
         * @param {number} pkEmployeeId The employee identifier (overrides the body\&#39;s EmployeeId).
         * @param {DeleteEmployeeShift} [deleteEmployeeShift] The delete request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdShiftsDelete(pkEmployeeId: number, deleteEmployeeShift?: DeleteEmployeeShift, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdShiftsDelete(pkEmployeeId, deleteEmployeeShift, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns all shifts for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdShiftsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeShiftItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdShiftsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a single shift to the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {EmployeeShiftRequest} [employeeShiftRequest] The shift to add.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdShiftsPost(pkEmployeeId: number, employeeShiftRequest?: EmployeeShiftRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdShiftsPost(pkEmployeeId, employeeShiftRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates the shift and/or shift-type assignment of an existing employee shift.
         * @param {number} pkEmployeeId The employee identifier (overrides the body\&#39;s EmployeeId).
         * @param {UpdateEmployeeShift} [updateEmployeeShift] The update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdShiftsPut(pkEmployeeId: number, updateEmployeeShift?: UpdateEmployeeShift, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdShiftsPut(pkEmployeeId, updateEmployeeShift, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee status entry.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} employeeStatusId The employee status entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet(pkEmployeeId: number, employeeStatusId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet(pkEmployeeId, employeeStatusId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the statuses and role-based permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdStatusesGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdStatusesGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deletes the specified employee status entry and its associated comment.  Mirrors ta-web `DELETE /api/Employee/Status`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} pkEmployeeStatusId The status entry identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete(pkEmployeeId: number, pkEmployeeStatusId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete(pkEmployeeId, pkEmployeeStatusId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates an existing employee status entry (hire-date flag, PBJ status type, comment).  Mirrors ta-web `PUT /api/Employee/Status`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} pkEmployeeStatusId The status entry identifier.
         * @param {UpdateEmployeeStatusRequest} [updateEmployeeStatusRequest] The update request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut(pkEmployeeId: number, pkEmployeeStatusId: number, updateEmployeeStatusRequest?: UpdateEmployeeStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut(pkEmployeeId, pkEmployeeStatusId, updateEmployeeStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a new status entry for the specified employee.  Mirrors ta-web `POST /api/Employee/AddStatus`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {AddEmployeeStatusRequest} [addEmployeeStatusRequest] The add request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdStatusesPost(pkEmployeeId: number, addEmployeeStatusRequest?: AddEmployeeStatusRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdStatusesPost(pkEmployeeId, addEmployeeStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reverses the caller\'s ENTIRE remaining micro-session undo stack for this employee in one  all-or-nothing operation.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdUndoAllPost(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UndoAllResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdUndoAllPost(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reverses the most recent remaining action in the caller\'s micro-session undo stack for  this employee.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdUndoPost(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UndoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdUndoPost(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ends the caller\'s undo micro-session for this employee view: purges the session\'s whole  stack. Fired by the FE on Profile-tab enter and on leaving the employee center. No lock  required — it can only destroy the caller\'s own history. Idempotent; 204 also when no  micro-session header rides the request.
         * @param {number} pkEmployeeId The primary key identifier of the employee (route symmetry; the purge is session-scoped).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdUndoSessionDelete(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdUndoSessionDelete(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the caller\'s micro-session undo stack for this employee, newest-first.
         * @param {number} pkEmployeeId The primary key identifier of the employee.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdUndoStackGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UndoStackResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdUndoStackGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the shift and work-pattern UI permission flags for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdWorkPatternConfigurationGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeWorkPatternConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdWorkPatternConfigurationGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee work pattern entry.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} workPatternId The employee work pattern identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet(pkEmployeeId: number, workPatternId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet(pkEmployeeId, workPatternId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returns the work patterns for the specified employee.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdWorkPatternsGet(pkEmployeeId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmployeeWorkPatternItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdWorkPatternsGet(pkEmployeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Adds a new work pattern entry for the employee.  Mirrors ta-web `POST /api/Employee/{employeeId}/workpattern`.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {AddEmployeeWorkPatternRequest} [addEmployeeWorkPatternRequest] Date and type of the new work pattern.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdWorkPatternsPost(pkEmployeeId: number, addEmployeeWorkPatternRequest?: AddEmployeeWorkPatternRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdWorkPatternsPost(pkEmployeeId, addEmployeeWorkPatternRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validates the requested pay period belongs to the employee and returns the recalculate-button state.
         * @param {number} pkEmployeeId The employee identifier.
         * @param {number} workingPayPeriodId The pay period identifier to validate and set as working.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch(pkEmployeeId: number, workingPayPeriodId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecalculateButtonStateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch(pkEmployeeId, workingPayPeriodId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieves the authorized employees for the logged-in employee and returns the grouped result set.
         * @param {FindEmployeeRequestV2} [findEmployeeRequestV2] Search, filter, sort, and paging options for the employee query.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesPost(findEmployeeRequestV2?: FindEmployeeRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupedEmployeePageResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesPost(findEmployeeRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Landing-page snapshot for Time & Attendance widgets: hours, OT, approaching OT,  punched in, and pending punch requests (missing-punch and time-change notifications  from the app — not absence/PTO). Scoped to employees the caller can view.  Hours dates come from the caller\'s pay-period group for every facility row.  Approaching OT is Hours that count toward period overtime (the pay type\'s  `…CountTowardsPeriodOvertime` flags, as in legacy), summed over each employee\'s own  current overtime period, vs that period\'s threshold (an employee with no period-OT rule is  left out, as legacy\'s 99999 \"never approaching\" does), for employees whose Hours the caller may  view. The pay periods are the ones containing today, not legacy\'s working and previous periods.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesTaDashboardGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesTaDashboardGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Soft-deletes one or more `EmployeeWorkPattern` rows. Replaces TaAPI  `DELETE /api/Employee/workpattern`. Returns 204 No Content on success.
         * @param {DeleteEmployeeWorkPatternRequestV2} [deleteEmployeeWorkPatternRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EmployeesWorkPatternDelete(deleteEmployeeWorkPatternRequestV2?: DeleteEmployeeWorkPatternRequestV2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EmployeesWorkPatternDelete(deleteEmployeeWorkPatternRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmployeeV2Api - factory interface
 * @export
 */
export const EmployeeV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeV2ApiFp(configuration)
    return {
        /**
         * The sibling of `checkDuplicateId`, with the same role-only authorization and the same  accepted risk: an existence probe on a non-secret, human-typed ID. It names no one. Create names  the holder when it refuses, but only after the caller\'s role at the new employee\'s labor levels  allows adding an employee with a clock ID; this call checks the JWT role alone. The answer is  the rule creation and the Clock Info tab\'s add enforce, so a free ID here is one the create call  will accept (in multi-facility mode per facility: HandPunch and Accuface route a row by its  holder\'s facility and send an all-clocks employee everywhere, so it does not rule out the same  ID under another facility). Call it while the Clock ID is typed. On submit, call create: it  refuses a taken ID with the holder\'s name and what to do, which this call cannot show.
         * @summary SPD-5664: returns whether a clock ID is already used by another employee, so the Add Employee  form can warn while the ID is typed instead of after the employee is saved.
         * @param {EmployeeV2ApiApiV2EmployeesCheckDuplicateClockIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesCheckDuplicateClockIdGet(requestParameters: EmployeeV2ApiApiV2EmployeesCheckDuplicateClockIdGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<ClockIdDuplicateCheckResponse> {
            return localVarFp.apiV2EmployeesCheckDuplicateClockIdGet(requestParameters.clockId, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization is role-only (the `[Authorize(Roles = ...)]` below) — unlike the create  path\'s `CheckLaborLevelAuthorizationAsync`, nothing here verifies the caller has any standing  at facilityId itself. A FacilityManager (or Support/Admin/System) token  scoped to one facility can pass a different facilityId and probe  employee-ID existence there, and in single-facility mode an omitted facilityId  answers tenant-wide. Accepted deliberately, matching `nextAvailableId`\'s existing,  already-shipped shape (SPD-5697 review) — this is an existence probe on a non-secret,  human-typed ID, not a data read, and tightening it would mean duplicating the labor-level  authorization engine on a read endpoint. Revisit if that calculus changes.
         * @summary Returns whether the given employee ID is already in use within a facility.
         * @param {EmployeeV2ApiApiV2EmployeesCheckDuplicateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesCheckDuplicateIdGet(requestParameters: EmployeeV2ApiApiV2EmployeesCheckDuplicateIdGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeIdDuplicateCheckResponse> {
            return localVarFp.apiV2EmployeesCheckDuplicateIdGet(requestParameters.employeeId, requestParameters.facilityId, requestParameters.excludePkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns clock-info permission flags for the logged-in user given exactly 10 labor-level IDs.  Mirrors ta-web `POST /api/Employee/AddClockPermission`.
         * @param {EmployeeV2ApiApiV2EmployeesClockInfoPermissionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesClockInfoPermissionsPost(requestParameters: EmployeeV2ApiApiV2EmployeesClockInfoPermissionsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<AddClockPermissionResponse> {
            return localVarFp.apiV2EmployeesClockInfoPermissionsPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new employee (heaviest write-side port of TaAPI `EmployeeController.CreateEmployee`).
         * @param {EmployeeV2ApiApiV2EmployeesCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesCreatePost(requestParameters: EmployeeV2ApiApiV2EmployeesCreatePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<CreateEmployeeResponse> {
            return localVarFp.apiV2EmployeesCreatePost(requestParameters.createEmployeeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The facility\'s custom-tab definitions: tabs, fields and dropdown options. Carries no  employee id, so the class-level `RequireSelfOrManager` filter no-ops here and the  caller\'s own `EmployeeCustomView` is the gate.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesCustomTabsGet(options?: AxiosRequestConfig): AxiosPromise<EmployeeCustomTabsResponseV2> {
            return localVarFp.apiV2EmployeesCustomTabsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the Licensing tab. Replaces TaAPI  `PUT /api/Employee/Employment/EmployeeLicense`. Returns the hydrated  OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeLicenseResponse.
         * @param {EmployeeV2ApiApiV2EmployeesEmploymentEmployeeLicensePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesEmploymentEmployeeLicensePut(requestParameters: EmployeeV2ApiApiV2EmployeesEmploymentEmployeeLicensePutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeLicenseResponse> {
            return localVarFp.apiV2EmployeesEmploymentEmployeeLicensePut(requestParameters.employeeLicenseUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the General employment tab. Replaces TaAPI  `PUT /api/Employee/Employment/General`. Returns `true` on success.
         * @param {EmployeeV2ApiApiV2EmployeesEmploymentGeneralPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesEmploymentGeneralPut(requestParameters: EmployeeV2ApiApiV2EmployeesEmploymentGeneralPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiV2EmployeesEmploymentGeneralPut(requestParameters.employeeEmploymentGeneralUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the Health tab. Replaces TaAPI `PUT /api/Employee/Employment/Health`.  Returns the hydrated OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeHealthResponse.
         * @param {EmployeeV2ApiApiV2EmployeesEmploymentHealthPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesEmploymentHealthPut(requestParameters: EmployeeV2ApiApiV2EmployeesEmploymentHealthPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeHealthResponse> {
            return localVarFp.apiV2EmployeesEmploymentHealthPut(requestParameters.employeeHealthUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the I-9 Documents tab. Replaces TaAPI  `PUT /api/Employee/Employment/I9Documents`. Returns the hydrated  OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeI9DocumentsResponse.
         * @param {EmployeeV2ApiApiV2EmployeesEmploymentI9DocumentsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesEmploymentI9DocumentsPut(requestParameters: EmployeeV2ApiApiV2EmployeesEmploymentI9DocumentsPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeI9DocumentsResponse> {
            return localVarFp.apiV2EmployeesEmploymentI9DocumentsPut(requestParameters.employeeI9DocumentsUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the authorized employee groups for the current employee based on the provided grouping and filter request.
         * @param {EmployeeV2ApiApiV2EmployeesGroupsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesGroupsPost(requestParameters: EmployeeV2ApiApiV2EmployeesGroupsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<EmployeeGroupsPageResult> {
            return localVarFp.apiV2EmployeesGroupsPost(requestParameters.findEmployeeGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the labor levels for the given filter type used for employee filtering.  Replaces ta-web\'s `GET /api/Employee/BudgetGroupLaborLevelsForFilter` and  `GET /api/Employee/DepartmentLaborLevelsForFilter`.
         * @param {EmployeeV2ApiApiV2EmployeesLaborLevelsForFilterTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesLaborLevelsForFilterTypeGet(requestParameters: EmployeeV2ApiApiV2EmployeesLaborLevelsForFilterTypeGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<LaborLevelResponse>> {
            return localVarFp.apiV2EmployeesLaborLevelsForFilterTypeGet(requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Release All Locks — every lock, every owner. Gated on the caller\'s legacy TA role being  the Administrator built-in (`Role.IsAdministrator`), matching LegacyApp, which only  shows this command when `role.IsAdministrator` (MainFormRibbonSetup.cs:136-137). The  check runs in the service; an identity-role restriction here would 403 every facility  caller, because `UserRoles.Admin` is a SaaS platform role facility users never carry  (SPD-5803).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesLocksDelete(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesLocksDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Release My Locks — all of the caller\'s locks, all sessions (legacy built-in).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesLocksMineDelete(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesLocksMineDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns identity and role-flag details for the currently authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesMeGet(options?: AxiosRequestConfig): AxiosPromise<LoggedInUserDetailResponse> {
            return localVarFp.apiV2EmployeesMeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the signed-in employee\'s own personal info (emergency contact, home address, email,  home phone) for the mobile / self-service surface.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesMePersonalInfoGet(options?: AxiosRequestConfig): AxiosPromise<EmployeePersonalInfoResponse> {
            return localVarFp.apiV2EmployeesMePersonalInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Self-service update of the authenticated employee\'s own personal info — address, emergency  contact, email and home phone. The caller is resolved from the JWT (mobile `me` route),  and the mobile client wraps its payload in a `body` envelope. Ports the mobile contact  update that had no V2 equivalent (SPD-5482).
         * @param {EmployeeV2ApiApiV2EmployeesMePersonalInfoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesMePersonalInfoPut(requestParameters: EmployeeV2ApiApiV2EmployeesMePersonalInfoPutRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesMePersonalInfoPut(requestParameters.updatePersonalInfoRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization is role-only — nothing verifies the caller has any standing at  facilityId itself. Same accepted-risk decision as `checkDuplicateId`  (SPD-5697 review): an existence probe on a non-secret, human-typed ID, not a data read.
         * @summary Returns the next available employee ID within a facility.
         * @param {EmployeeV2ApiApiV2EmployeesNextAvailableIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesNextAvailableIdGet(requestParameters: EmployeeV2ApiApiV2EmployeesNextAvailableIdGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<NextAvailableEmployeeIdResponse> {
            return localVarFp.apiV2EmployeesNextAvailableIdGet(requestParameters.facilityId, requestParameters.startingFrom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the accrual group for the specified employee with an effective date.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAccrualGroupPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAccrualGroupPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeAccrualGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all accrual groups accessible to the specified employee,  filtered by the employee\'s facility.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAccrualGroupsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AccrualGroupResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAccrualGroupsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * The returned labor levels are filtered based on the employee\'s facility.  This endpoint always returns HTTP 200 with a consistent response shape.  Caching must be scoped per authenticated user and employee.
         * @summary Returns all labor levels available to the specified employee,  grouped by labor level index.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAllLaborLevelsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAllLaborLevelsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAllLaborLevelsGetRequest, options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: Array<LaborLevelResponseBase>; }> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAllLaborLevelsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the Employee entity itself,  ordered by database timestamp ascending.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the data behind the employee\'s Authorizations tab — the  EmployeeAuthorization record merged with every EmployeeAuthorizationLaborLevel row —  ordered by database timestamp ascending (SPD-5600).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuthorizationAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disables (soft-deletes) the authorization for the specified employee. Mirrors TaAPI  `DELETE {employeeId}/Authorization`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuthorizationDelete(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns authorization settings and role-based permission flags for the specified employee.  When the caller\'s role lacks view permission, returns 200 with  `IsAuthorizationTabVisible = false` and all other fields at defaults.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeAuthorizationResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuthorizationGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Clones an existing labor-level row on the employee\'s authorization into a new row.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePostRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeAuthorizationLaborLevelItem> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost(requestParameters.pkEmployeeId, requestParameters.authorizationLaborLevelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-deletes a labor-level row from the employee\'s authorization.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete(requestParameters.pkEmployeeId, requestParameters.laborLevelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a labor-level row on the employee\'s authorization. `EmployeeId` and  `AuthorizationLaborLevelId` are taken from the route, overriding the body.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeAuthorizationLaborLevelItem> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut(requestParameters.pkEmployeeId, requestParameters.laborLevelId, requestParameters.updateEmployeeAuthorizationLaborLevelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a new labor-level row to the employee\'s authorization. `EmployeeId` is taken  from the route, overriding the body.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPostRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeAuthorizationLaborLevelItem> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost(requestParameters.pkEmployeeId, requestParameters.addEmployeeAuthorizationLaborLevelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Enables authorization for the specified employee (creates an authorization record with  generated defaults). Mirrors TaAPI `POST {employeeId}/Authorization`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPostRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeAuthorizationResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuthorizationPost(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the authorization details for the specified employee. Mirrors TaAPI  `PUT {employeeId}/Authorization`: the route employee ID overwrites the body\'s.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPutRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeAuthorizationResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuthorizationPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeAuthorizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the role IDs available for the employee authorization combobox.  Always includes \"No Authorization (Built In)\"; includes \"Administrator (Built In)\"  only when the caller is an administrator.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationRolesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdAuthorizationRolesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationRolesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdAuthorizationRolesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the base schedule group for the specified employee with an effective date.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdBaseScheduleGroupPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdBaseScheduleGroupPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeBaseScheduleGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all base schedule groups accessible to the specified employee,  filtered by the employee\'s facility.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdBaseScheduleGroupsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<BaseScheduleGroupResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdBaseScheduleGroupsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assigns or unassigns all facility-matched time clocks to/from the clock ID at the given index  by toggling the `AssignAllTimeClocks` flag and clearing all individual assignment rows.  Mirrors ta-web `PATCH /api/Employee/EmployeeClockInfo/AssignmentAll`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatchRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeClockInfoResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch(requestParameters.pkEmployeeId, requestParameters.index, requestParameters.setEmployeeClockInfoAllAssignmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assigns or unassigns a single time clock to/from the clock ID at the given index.  Mirrors ta-web `PATCH /api/Employee/EmployeeClockInfo/Assignment`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatchRequest, options?: AxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch(requestParameters.pkEmployeeId, requestParameters.index, requestParameters.setEmployeeClockInfoAssignmentsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee clock info entry.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet(requestParameters.pkEmployeeId, requestParameters.clockIndex, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the time clocks accessible to the specified employee based on facility matching.  An inactive clock, or one of an inactive group, is listed only while it is explicitly  assigned, flagged `isInactive` (SPD-6024).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<FacilityTimeClockResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns clock ID info for the specified employee at the given index.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeClockInfoResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdClockInfoGet(requestParameters.pkEmployeeId, requestParameters.index, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the labor level IDs stored on the clock ID at the given index for an employee.  Requires `AllowMultipleClockIDs` to be enabled.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet(requestParameters.pkEmployeeId, requestParameters.index, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Writes the 10-element labor level FK array onto the clock ID at the given index.  Mirrors ta-web `PUT /api/Employee/EmployeeClockInfo/LaborLevels`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPutRequest, options?: AxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut(requestParameters.pkEmployeeId, requestParameters.index, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lists every clock ID belonging to the specified employee, in the order the clock-scoped  endpoints index them.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoListGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoListGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeClockInfoListResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdClockInfoListGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a new clock ID record for the specified employee.  Mirrors ta-web `POST /api/Employee/EmployeeClockInfo`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPostRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeClockInfoResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdClockInfoPost(requestParameters.pkEmployeeId, requestParameters.addEmployeeClockInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing clock ID record for the specified employee.  Mirrors ta-web `PUT /api/Employee/EmployeeClockInfo`.  Only non-null request fields are applied (patch semantics).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdClockInfoPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPutRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeClockInfoResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdClockInfoPut(requestParameters.pkEmployeeId, requestParameters.clockIndex, requestParameters.updateEmployeeClockInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the data behind the employee\'s Contact tab — the  EmployeeExtended record (address / emergency contact fields) merged with every  EmployeeContact row (phones / email) — ordered by database timestamp ascending (SPD-5600).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdContactInfoAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdContactInfoAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the contact information and role-based permission flags for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdContactInfoGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeContactInfoResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdContactInfoGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the contact information for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdContactInfoPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdContactInfoPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeContactInfoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The employee\'s custom-field values, each with the raw stored string and the typed  projections LegacyApp\'s converters produce. Self-or-manager guarded via the class-level  `RequireSelfOrManager(\"pkEmployeeId\")` filter, then the caller\'s  `EmployeeCustomView` for this employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdCustomValuesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeCustomValuesResponseV2> {
            return localVarFp.apiV2EmployeesPkEmployeeIdCustomValuesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Batch write for the employee\'s custom values with LegacyApp\'s employee-form semantics:  singleton/cell upserts, historical-group row adds (one shared key per row set), and  group removals. Values are stored in the exact strings legacy\'s controls write, so the  WinForms app renders web edits untouched.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdCustomValuesPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesPutRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeCustomValuesResponseV2> {
            return localVarFp.apiV2EmployeesPkEmployeeIdCustomValuesPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeCustomValuesRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the effective-date UI configuration for the given employee and effective date type.  Equivalent to ta-web\'s `GET /api/Employee/EffectiveDateConfiguration`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGetRequest, options?: AxiosRequestConfig): AxiosPromise<EffectiveDateConfigurationResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet(requestParameters.pkEmployeeId, requestParameters.effectiveDateType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the employee ID for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmployeeIdPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmployeeIdPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee\'s licensing record.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the employee status types available for the given employee\'s role.  Mirrors ta-web\'s `GET /api/Employee/{employeeId}/EmployeeStatusTypeList`.  When the role has `EmployeeStatusesNoTerminatedStatusTypes` set, only  `ConsideredHired` types are returned; otherwise all types are returned.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeStatusTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmployeeStatusTypesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeStatusTypesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<OpenShiftsBusinessObjectsResponseEmployeeCenterEmployeeStatusTypeResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmployeeStatusTypesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the employment audit records for the specified employee,  ordered by database timestamp ascending.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmploymentAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-deletes a single in-service row. Replaces TaAPI  `DELETE /api/Employee/{employeeId}/Employment/EmployeeInService/{inServiceId}`.  Returns a boolean (TaAPI parity).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete(requestParameters.pkEmployeeId, requestParameters.inServiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee in-service entry,  ordered by database timestamp ascending (SPD-5600).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.employeeInServiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all in-service records taken by the specified employee,  each with its in-service definition including mandatory and taken flags.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeInServiceItem>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns general employment data and permission flags for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentGeneralGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentGeneralGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentGeneralGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeEmploymentGeneralResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmploymentGeneralGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the health record and UI configuration for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentHealthGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentHealthGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentHealthGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeHealthResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmploymentHealthGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the I-9 documents and employment eligibility details for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeI9DocumentsResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the in-service list for the specified employee with mandatory and taken flags.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGetRequest, options?: AxiosRequestConfig): AxiosPromise<InServiceListResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet(requestParameters.pkEmployeeId, requestParameters.serviceCategory, requestParameters.serviceGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds one or more in-service records. Replaces TaAPI  `POST /api/Employee/{employeeId}/Employment/InService`. Returns the count of  successfully inserted rows (TaAPI parity — partial success).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServicePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentInServicePost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServicePostRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmploymentInServicePost(requestParameters.pkEmployeeId, requestParameters.employeeInServiceAddRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the licensing information and role-based permission flags for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentLicenseGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdEmploymentLicenseGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentLicenseGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeLicenseResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdEmploymentLicenseGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the header details for the specified employee. Opening someone in  Employee Center (and creating an employee) records them on the caller\'s  Recently Viewed list (SPD-4205). A recording failure is logged and does not  fail the header response.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHeaderGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHeaderGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHeaderGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeHeaderDetails> {
            return localVarFp.apiV2EmployeesPkEmployeeIdHeaderGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee\'s health record.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHealthAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHealthAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHealthAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdHealthAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the history records and role-based permission flags for the specified employee.  Always returns 200 — use `IsEmployeeHistoryGridVisible` to determine view access.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoriesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeHistoryResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdHistoriesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the minimum effective date the add-history modal may use for the given history  type — the caller-role-aware port of TaAPI `POST /api/Employee/minhistorydate`  (ta-legacy `PayPeriodGroup.StartDateOfEarliestOpenPayPeriodForLoggedIn`): the start of  the pay period following the employee\'s latest closed-or-approved period, with the  historical-edit carve-outs (labor levels / accrual group) returning 2001-01-01.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGetRequest, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet(requestParameters.pkEmployeeId, requestParameters.historyType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a history entry (labor level, pay rule, base schedule group, holiday group, or  accrual group) for the specified employee at an effective date.  Committing port of TaAPI `POST /api/Employee/AddHistoryType`: ta-web only stages the  insert in its session unit of work (committed exclusively by the SaveEmployee flow the web  FE removed), so the row never reaches the tenant DB — this endpoint persists atomically.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoriesPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesPostRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdHistoriesPost(requestParameters.pkEmployeeId, requestParameters.addEmployeeHistoryTypeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee history entry,  ordered by database timestamp ascending.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.employeeRecordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes the specified history entry for the given employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete(requestParameters.pkEmployeeId, requestParameters.pkHistoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the available history types and their selectable values for the specified employee.  Each entry contains a history type (e.g., a configured labor level, PayRule, BaseScheduleGroup)  and the values the employee may select from, filtered by facility and role.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHistoryTypesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryTypesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeHistoryTypeResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdHistoryTypesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the holiday group for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHolidayGroupPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdHolidayGroupPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeHolidayGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all holiday groups accessible to the specified employee,  filtered by the employee\'s facility.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdHolidayGroupsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<HolidayGroupResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdHolidayGroupsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the journal entries and role-based permission flags for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdJournalsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeJournalResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdJournalsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee journal entry,  ordered by database timestamp ascending (SPD-5600).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.pkEmployeeJournalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes the specified employee journal entry.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete(requestParameters.pkEmployeeId, requestParameters.pkEmployeeJournalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new employee journal entry for the specified employee, based on the provided request data.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdJournalsPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPostRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeJournalItem> {
            return localVarFp.apiV2EmployeesPkEmployeeIdJournalsPost(requestParameters.pkEmployeeId, requestParameters.createEmployeeJournalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing employee journal entry for the specified employee, based on the provided request data.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdJournalsPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPutRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeJournalItem> {
            return localVarFp.apiV2EmployeesPkEmployeeIdJournalsPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeJournalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the labor levels at the specified index, filtered to those that belong to  the employee\'s facility (multi-facility environments only).  Equivalent to ta-web\'s `GET /api/Employee/{employeeId}/LaborLevel/{level}`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelLevelGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLaborLevelLevelGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelLevelGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<LaborLevelResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdLaborLevelLevelGet(requestParameters.pkEmployeeId, requestParameters.level, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validates and normalizes a proposed set of labor level IDs for an employee without persisting  any changes. Mirrors ta-web `PATCH /api/Employee/EmployeeLaborLevelsCheck`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsCheckPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsCheckPatchRequest, options?: AxiosRequestConfig): AxiosPromise<Array<number>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch(requestParameters.pkEmployeeId, requestParameters.changedLevel, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the labor levels for the specified employee with an effective date.  Replaces ta-web `PUT /api/Employee/EmployeeLaborLevels`.  Requires `EmployeeMainEdit` on the caller\'s role.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLaborLevelsPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdLaborLevelsPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeLaborLevelsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the license types available for the specified employee\'s facility state,  as a dictionary of `LicenseType` integer value to friendly display name.  Always includes `Unknown` and `NotApplicable`, followed by state-specific types.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLicenseTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLicenseTypesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLicenseTypesGetRequest, options?: AxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.apiV2EmployeesPkEmployeeIdLicenseTypesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Releases the caller\'s own lock on this employee (navigate away / deselect).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLockDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdLockDelete(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lock-on-view acquire/refresh (SPD-5570). Returns holder info instead of erroring on  conflict.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLockPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockPostRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeLockStatus> {
            return localVarFp.apiV2EmployeesPkEmployeeIdLockPost(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Release Current Employee\'s Locks — even others\'; requires legacy  `Role.AllowReleasingOfLock`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLocksDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdLocksDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLocksDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdLocksDelete(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the narrow projection consumed by the Employee Settings → Main tab. Replaces  the legacy TaAPI `GET /api/Employee/{pkEmployeeId}?doRefreshEmployee=...`: the FE  only binds ~25 of the 100+ fields from the legacy detail dump, so this endpoint returns  just those. SaaSAPI is stateless per request, so the `doRefreshEmployee`  cache-bypass parameter is dropped — every call is fresh.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdMainGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdMainGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdMainGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeMainTabResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdMainGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee\'s miscellaneous settings (extended) record.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdMiscAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdMiscAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns miscellaneous settings for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdMiscGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeMiscSettingsResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdMiscGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates miscellaneous settings for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdMiscPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdMiscPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeMiscSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the pay period group assigned to the employee via their pay rule.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayPeriodGroupGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayPeriodGroupGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayPeriodGroupGetRequest, options?: AxiosRequestConfig): AxiosPromise<PayPeriodGroupResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPayPeriodGroupGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee pay rate entry.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.payRateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-deletes a single pay-rate row. Replaces TaAPI  `DELETE /api/Employee/{employeeId}/PayRate/{payRateId}`. Returns `true` when  a row was removed, `false` when no matching row existed (TaAPI parity).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete(requestParameters.pkEmployeeId, requestParameters.payRateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replaces TaAPI `PUT /api/Employee/{employeeId}/PayRate/{payRateId}`. Updates the  `PayTypeId` / `ShiftId` / `Note` on an existing pay-rate row. The route  pkEmployeeId and payRateId overwrite the body\'s  `EmployeeId` and `Id` respectively (TaAPI parity). Requires  `EmployeePayRatesAdd` on the caller\'s role.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatePayRateIdPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPayRatePayRateIdPut(requestParameters.pkEmployeeId, requestParameters.payRateId, requestParameters.employeePayRateUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replaces TaAPI `POST /api/Employee/PayRate`. Adds a new `EmployeePayRate` row;  returns the new PK. Requires `EmployeePayRatesAdd` on the caller\'s role.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatePost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePostRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPayRatePost(requestParameters.pkEmployeeId, requestParameters.employeePayRateAddRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the pay rates and role-based permission flags for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeePayRatesResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPayRatesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns facility-wide pay rate configuration settings and whether the caller  has permission to view pay rates for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesSettingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRatesSettingsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesSettingsGetRequest, options?: AxiosRequestConfig): AxiosPromise<PayRateSettingsResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPayRatesSettingsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the pay rule for the specified employee with an effective date.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRulePut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulePutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPayRulePut(requestParameters.pkEmployeeId, requestParameters.updateEmployeePayRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all pay rules accessible to the specified employee,  filtered by the employee\'s facility and role-based restrictions.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayRulesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<PayRuleResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPayRulesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all pay types accessible to the specified employee,  filtered by facility binding and role-based restrictions.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPayTypesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayTypesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<PayTypeEntityResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPayTypesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Accessible to managers (FacilityManager, Admin, System, Support) acting on any employee,  and to an authenticated Employee acting on themselves — enforced by OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute.
         * @summary Returns a time-limited SAS URL for the employee\'s profile picture.  The URL validity period is controlled by `ProfilePictureServiceV2.SasExpiry`.  The underlying filename is resolved from an in-memory cache and only falls back  to a database query on a cache miss.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePictureGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdProfilePictureGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePictureGetRequest, options?: AxiosRequestConfig): AxiosPromise<ProfilePictureUrlResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdProfilePictureGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Accessible to managers (FacilityManager, Admin, System, Support) acting on any employee,  and to an authenticated Employee uploading their own picture — enforced by OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute.
         * @summary Uploads a new profile picture for the employee, saves the filename to the facility  database, and refreshes the in-memory cache so subsequent GET requests immediately  reflect the new image.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePicturePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdProfilePicturePost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePicturePostRequest, options?: AxiosRequestConfig): AxiosPromise<ProfilePictureUrlResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdProfilePicturePost(requestParameters.pkEmployeeId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the employee\'s first/middle/last name + tag. Replaces TaAPI  `PUT /api/Employee`. Requires `EmployeeMainEdit` on the caller\'s role.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdPut(requestParameters.pkEmployeeId, requestParameters.employeeMainInfoUpdateRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the salaried hours for the specified employee.  The value is stored as minutes in the database and returned as hours (minutes / 60).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdSalariedHoursGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursGetRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2EmployeesPkEmployeeIdSalariedHoursGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the salaried hours for the specified employee.  The value is stored as minutes in the database (round(hours * 60)).
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdSalariedHoursPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdSalariedHoursPut(requestParameters.pkEmployeeId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolves the appropriate employee shift type for a candidate shift without persisting.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAdjustmentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsAdjustmentPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAdjustmentPostRequest, options?: AxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiV2EmployeesPkEmployeeIdShiftsAdjustmentPost(requestParameters.pkEmployeeId, requestParameters.adjustEmployeeShift, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee shift.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdShiftsAuditsGet(requestParameters.pkEmployeeId, requestParameters.employeeShiftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes one or more shifts from the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdShiftsDelete(requestParameters.pkEmployeeId, requestParameters.deleteEmployeeShift, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all shifts for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeShiftItem>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdShiftsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a single shift to the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPostRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdShiftsPost(requestParameters.pkEmployeeId, requestParameters.employeeShiftRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates the shift and/or shift-type assignment of an existing employee shift.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdShiftsPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdShiftsPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeShift, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee status entry.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.employeeStatusId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the statuses and role-based permission flags for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdStatusesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeStatusResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdStatusesGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes the specified employee status entry and its associated comment.  Mirrors ta-web `DELETE /api/Employee/Status`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete(requestParameters.pkEmployeeId, requestParameters.pkEmployeeStatusId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing employee status entry (hire-date flag, PBJ status type, comment).  Mirrors ta-web `PUT /api/Employee/Status`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut(requestParameters.pkEmployeeId, requestParameters.pkEmployeeStatusId, requestParameters.updateEmployeeStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a new status entry for the specified employee.  Mirrors ta-web `POST /api/Employee/AddStatus`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdStatusesPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPostRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdStatusesPost(requestParameters.pkEmployeeId, requestParameters.addEmployeeStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reverses the caller\'s ENTIRE remaining micro-session undo stack for this employee in one  all-or-nothing operation.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoAllPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdUndoAllPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoAllPostRequest, options?: AxiosRequestConfig): AxiosPromise<UndoAllResult> {
            return localVarFp.apiV2EmployeesPkEmployeeIdUndoAllPost(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reverses the most recent remaining action in the caller\'s micro-session undo stack for  this employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdUndoPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoPostRequest, options?: AxiosRequestConfig): AxiosPromise<UndoResult> {
            return localVarFp.apiV2EmployeesPkEmployeeIdUndoPost(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ends the caller\'s undo micro-session for this employee view: purges the session\'s whole  stack. Fired by the FE on Profile-tab enter and on leaving the employee center. No lock  required — it can only destroy the caller\'s own history. Idempotent; 204 also when no  micro-session header rides the request.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoSessionDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdUndoSessionDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoSessionDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdUndoSessionDelete(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the caller\'s micro-session undo stack for this employee, newest-first.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoStackGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdUndoStackGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoStackGetRequest, options?: AxiosRequestConfig): AxiosPromise<UndoStackResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdUndoStackGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the shift and work-pattern UI permission flags for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternConfigurationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdWorkPatternConfigurationGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternConfigurationGetRequest, options?: AxiosRequestConfig): AxiosPromise<EmployeeWorkPatternConfigurationResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdWorkPatternConfigurationGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the audit records for the specified employee work pattern entry.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<AuditResponse>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.workPatternId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the work patterns for the specified employee.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdWorkPatternsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsGetRequest, options?: AxiosRequestConfig): AxiosPromise<Array<EmployeeWorkPatternItem>> {
            return localVarFp.apiV2EmployeesPkEmployeeIdWorkPatternsGet(requestParameters.pkEmployeeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Adds a new work pattern entry for the employee.  Mirrors ta-web `POST /api/Employee/{employeeId}/workpattern`.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdWorkPatternsPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsPostRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesPkEmployeeIdWorkPatternsPost(requestParameters.pkEmployeeId, requestParameters.addEmployeeWorkPatternRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validates the requested pay period belongs to the employee and returns the recalculate-button state.
         * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatchRequest, options?: AxiosRequestConfig): AxiosPromise<RecalculateButtonStateResponse> {
            return localVarFp.apiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch(requestParameters.pkEmployeeId, requestParameters.workingPayPeriodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves the authorized employees for the logged-in employee and returns the grouped result set.
         * @param {EmployeeV2ApiApiV2EmployeesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesPost(requestParameters: EmployeeV2ApiApiV2EmployeesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GroupedEmployeePageResult> {
            return localVarFp.apiV2EmployeesPost(requestParameters.findEmployeeRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Landing-page snapshot for Time & Attendance widgets: hours, OT, approaching OT,  punched in, and pending punch requests (missing-punch and time-change notifications  from the app — not absence/PTO). Scoped to employees the caller can view.  Hours dates come from the caller\'s pay-period group for every facility row.  Approaching OT is Hours that count toward period overtime (the pay type\'s  `…CountTowardsPeriodOvertime` flags, as in legacy), summed over each employee\'s own  current overtime period, vs that period\'s threshold (an employee with no period-OT rule is  left out, as legacy\'s 99999 \"never approaching\" does), for employees whose Hours the caller may  view. The pay periods are the ones containing today, not legacy\'s working and previous periods.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesTaDashboardGet(options?: AxiosRequestConfig): AxiosPromise<TaDashboardResponse> {
            return localVarFp.apiV2EmployeesTaDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Soft-deletes one or more `EmployeeWorkPattern` rows. Replaces TaAPI  `DELETE /api/Employee/workpattern`. Returns 204 No Content on success.
         * @param {EmployeeV2ApiApiV2EmployeesWorkPatternDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EmployeesWorkPatternDelete(requestParameters: EmployeeV2ApiApiV2EmployeesWorkPatternDeleteRequest = {}, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiV2EmployeesWorkPatternDelete(requestParameters.deleteEmployeeWorkPatternRequestV2, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiV2EmployeesCheckDuplicateClockIdGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesCheckDuplicateClockIdGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesCheckDuplicateClockIdGetRequest {
    /**
     * The clock ID to check; 0 or omitted answers 400.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesCheckDuplicateClockIdGet
     */
    readonly clockId?: number

    /**
     * The facility the employee will be created under, the Facility selector\&#39;s value the create  request carries as &#x60;facilityId&#x60; (the same facility labor level ID &#x60;checkDuplicateId&#x60;  takes); required in multi-facility mode, null or omitted otherwise.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesCheckDuplicateClockIdGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for apiV2EmployeesCheckDuplicateIdGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesCheckDuplicateIdGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesCheckDuplicateIdGetRequest {
    /**
     * The employee ID to check.
     * @type {string}
     * @memberof EmployeeV2ApiApiV2EmployeesCheckDuplicateIdGet
     */
    readonly employeeId?: string

    /**
     * Required in multi-facility mode; pass null or omit for single-facility. This is the labor  level ID for the employee\&#39;s Facility labor level (the same value used to populate the  \&quot;Facility\&quot; selector on the employee create/edit form) — not the SaaS tenant\&#39;s facility GUID  or any other facility identifier. A value from the wrong ID space is rejected with 400  rather than silently scoping to a facility that doesn\&#39;t exist.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesCheckDuplicateIdGet
     */
    readonly facilityId?: number

    /**
     * Pass the employee\&#39;s own PkEmployeeId when pre-checking a rename on the edit-employee-ID  field, so their own current ID isn\&#39;t reported as a duplicate of itself. Omit when  pre-checking a new employee\&#39;s ID at creation.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesCheckDuplicateIdGet
     */
    readonly excludePkEmployeeId?: number
}

/**
 * Request parameters for apiV2EmployeesClockInfoPermissionsPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesClockInfoPermissionsPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesClockInfoPermissionsPostRequest {
    /**
     * An array of exactly 10 labor level PKs corresponding to the clock ID\&#39;s labor level slots.
     * @type {Array<number>}
     * @memberof EmployeeV2ApiApiV2EmployeesClockInfoPermissionsPost
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for apiV2EmployeesCreatePost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesCreatePostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesCreatePostRequest {
    /**
     * The create-employee request body.
     * @type {CreateEmployeeRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesCreatePost
     */
    readonly createEmployeeRequest?: CreateEmployeeRequest
}

/**
 * Request parameters for apiV2EmployeesEmploymentEmployeeLicensePut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesEmploymentEmployeeLicensePutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesEmploymentEmployeeLicensePutRequest {
    /**
     * 
     * @type {EmployeeLicenseUpdateRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesEmploymentEmployeeLicensePut
     */
    readonly employeeLicenseUpdateRequestV2?: EmployeeLicenseUpdateRequestV2
}

/**
 * Request parameters for apiV2EmployeesEmploymentGeneralPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesEmploymentGeneralPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesEmploymentGeneralPutRequest {
    /**
     * 
     * @type {EmployeeEmploymentGeneralUpdateRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesEmploymentGeneralPut
     */
    readonly employeeEmploymentGeneralUpdateRequestV2?: EmployeeEmploymentGeneralUpdateRequestV2
}

/**
 * Request parameters for apiV2EmployeesEmploymentHealthPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesEmploymentHealthPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesEmploymentHealthPutRequest {
    /**
     * 
     * @type {EmployeeHealthUpdateRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesEmploymentHealthPut
     */
    readonly employeeHealthUpdateRequestV2?: EmployeeHealthUpdateRequestV2
}

/**
 * Request parameters for apiV2EmployeesEmploymentI9DocumentsPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesEmploymentI9DocumentsPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesEmploymentI9DocumentsPutRequest {
    /**
     * 
     * @type {EmployeeI9DocumentsUpdateRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesEmploymentI9DocumentsPut
     */
    readonly employeeI9DocumentsUpdateRequestV2?: EmployeeI9DocumentsUpdateRequestV2
}

/**
 * Request parameters for apiV2EmployeesGroupsPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesGroupsPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesGroupsPostRequest {
    /**
     * The employee group search and filter request. When the request body is null, an empty request is used  to keep the endpoint behavior stable and avoid null-reference issues.
     * @type {FindEmployeeGroupRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesGroupsPost
     */
    readonly findEmployeeGroupRequest?: FindEmployeeGroupRequest
}

/**
 * Request parameters for apiV2EmployeesLaborLevelsForFilterTypeGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesLaborLevelsForFilterTypeGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesLaborLevelsForFilterTypeGetRequest {
    /**
     * Which configured labor level index to resolve.
     * @type {LaborLevelFilterType}
     * @memberof EmployeeV2ApiApiV2EmployeesLaborLevelsForFilterTypeGet
     */
    readonly type: LaborLevelFilterType
}

/**
 * Request parameters for apiV2EmployeesMePersonalInfoPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesMePersonalInfoPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesMePersonalInfoPutRequest {
    /**
     * The personal-info update, wrapped in a &#x60;body&#x60; envelope.
     * @type {UpdatePersonalInfoRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesMePersonalInfoPut
     */
    readonly updatePersonalInfoRequestV2?: UpdatePersonalInfoRequestV2
}

/**
 * Request parameters for apiV2EmployeesNextAvailableIdGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesNextAvailableIdGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesNextAvailableIdGetRequest {
    /**
     * Facility to scope the search. Required in multi-facility mode; pass null or omit for single-facility.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesNextAvailableIdGet
     */
    readonly facilityId?: number

    /**
     * When provided, returns the smallest integer ≥ this value not already in use.  When null, returns max existing numeric ID + 1.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesNextAvailableIdGet
     */
    readonly startingFrom?: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAccrualGroupPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupPut
     */
    readonly pkEmployeeId: number

    /**
     * The request containing the accrual group information.
     * @type {UpdateEmployeeAccrualGroupRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupPut
     */
    readonly updateEmployeeAccrualGroupRequest?: UpdateEmployeeAccrualGroupRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAccrualGroupsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAllLaborLevelsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAllLaborLevelsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAllLaborLevelsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAllLaborLevelsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuditsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuthorizationAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationAuditsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuthorizationDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationDeleteRequest {
    /**
     * The employee whose authorization is removed.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationDelete
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuthorizationGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePostRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost
     */
    readonly pkEmployeeId: number

    /**
     * The source row identifier to clone.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost
     */
    readonly authorizationLaborLevelId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDeleteRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete
     */
    readonly pkEmployeeId: number

    /**
     * The authorization labor-level row identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete
     */
    readonly laborLevelId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut
     */
    readonly pkEmployeeId: number

    /**
     * The authorization labor-level row identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut
     */
    readonly laborLevelId: number

    /**
     * The update request body.
     * @type {UpdateEmployeeAuthorizationLaborLevelRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut
     */
    readonly updateEmployeeAuthorizationLaborLevelRequest?: UpdateEmployeeAuthorizationLaborLevelRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPostRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost
     */
    readonly pkEmployeeId: number

    /**
     * The add request body.
     * @type {AddEmployeeAuthorizationLaborLevelRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost
     */
    readonly addEmployeeAuthorizationLaborLevelRequest?: AddEmployeeAuthorizationLaborLevelRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuthorizationPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPostRequest {
    /**
     * The employee to enable authorization for.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPost
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuthorizationPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPutRequest {
    /**
     * The employee whose authorization is updated.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPut
     */
    readonly pkEmployeeId: number

    /**
     * The update payload.
     * @type {UpdateEmployeeAuthorizationRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPut
     */
    readonly updateEmployeeAuthorizationRequest?: UpdateEmployeeAuthorizationRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdAuthorizationRolesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationRolesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationRolesGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationRolesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdBaseScheduleGroupPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupPut
     */
    readonly pkEmployeeId: number

    /**
     * The request containing the base schedule group information.
     * @type {UpdateEmployeeBaseScheduleGroupRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupPut
     */
    readonly updateEmployeeBaseScheduleGroupRequest?: UpdateEmployeeBaseScheduleGroupRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdBaseScheduleGroupsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatchRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatchRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch
     */
    readonly pkEmployeeId: number

    /**
     * Zero-based clock ID index ordered by PK. Defaults to 0.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch
     */
    readonly index?: number

    /**
     * Whether to assign or unassign all clocks.
     * @type {SetEmployeeClockInfoAllAssignmentsRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch
     */
    readonly setEmployeeClockInfoAllAssignmentsRequest?: SetEmployeeClockInfoAllAssignmentsRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatchRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatchRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch
     */
    readonly pkEmployeeId: number

    /**
     * Zero-based clock ID index ordered by PK. Defaults to 0.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch
     */
    readonly index?: number

    /**
     * The time clock PK and whether it should be assigned or unassigned.
     * @type {SetEmployeeClockInfoAssignmentsRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch
     */
    readonly setEmployeeClockInfoAssignmentsRequest?: SetEmployeeClockInfoAssignmentsRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet
     */
    readonly pkEmployeeId: number

    /**
     * The zero-based index of the clock info entry.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet
     */
    readonly clockIndex: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdClockInfoGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoGet
     */
    readonly pkEmployeeId: number

    /**
     * Zero-based clock ID index ordered by PK. Defaults to 0.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoGet
     */
    readonly index?: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet
     */
    readonly pkEmployeeId: number

    /**
     * Zero-based clock ID index ordered by PK. Defaults to 0.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet
     */
    readonly index?: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut
     */
    readonly pkEmployeeId: number

    /**
     * Zero-based clock ID index ordered by PK. Defaults to 0.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut
     */
    readonly index?: number

    /**
     * Exactly 10 labor level PKs. Position i maps to &#x60;FkLaborLevel{i}Id&#x60;. Pass 0 to clear a slot.
     * @type {Array<number>}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdClockInfoListGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoListGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoListGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoListGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdClockInfoPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPostRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPost
     */
    readonly pkEmployeeId: number

    /**
     * The add request.
     * @type {AddEmployeeClockInfoRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPost
     */
    readonly addEmployeeClockInfoRequest?: AddEmployeeClockInfoRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdClockInfoPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPut
     */
    readonly pkEmployeeId: number

    /**
     * Zero-based clock ID index ordered by PK. Defaults to 0.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPut
     */
    readonly clockIndex?: number

    /**
     * The partial update request.
     * @type {UpdateEmployeeClockInfoRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPut
     */
    readonly updateEmployeeClockInfoRequest?: UpdateEmployeeClockInfoRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdContactInfoAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoAuditsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdContactInfoGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdContactInfoPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoPut
     */
    readonly pkEmployeeId: number

    /**
     * The update request.
     * @type {UpdateEmployeeContactInfoRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoPut
     */
    readonly updateEmployeeContactInfoRequest?: UpdateEmployeeContactInfoRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdCustomValuesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesGetRequest {
    /**
     * The primary key identifier of the employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdCustomValuesPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesPutRequest {
    /**
     * The primary key identifier of the employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesPut
     */
    readonly pkEmployeeId: number

    /**
     * The batch of writes.
     * @type {UpdateEmployeeCustomValuesRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesPut
     */
    readonly updateEmployeeCustomValuesRequestV2?: UpdateEmployeeCustomValuesRequestV2
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGetRequest {
    /**
     * The target employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet
     */
    readonly pkEmployeeId: number

    /**
     * Type driving Day One radio-button availability.
     * @type {EffectiveDateType}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet
     */
    readonly effectiveDateType?: EffectiveDateType
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmployeeIdPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeIdPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeIdPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeIdPut
     */
    readonly pkEmployeeId: number

    /**
     * The update request.
     * @type {UpdateEmployeeIdRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeIdPut
     */
    readonly updateEmployeeIdRequest?: UpdateEmployeeIdRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmployeeStatusTypesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeStatusTypesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeStatusTypesGetRequest {
    /**
     * The primary key of the target employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeStatusTypesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmploymentAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentAuditsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete
     */
    readonly inServiceId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet
     */
    readonly pkEmployeeId: number

    /**
     * The employee in-service entry identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet
     */
    readonly employeeInServiceId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmploymentGeneralGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentGeneralGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentGeneralGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentGeneralGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmploymentHealthGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentHealthGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentHealthGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentHealthGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet
     */
    readonly pkEmployeeId: number

    /**
     * Category filter: &#x60;All&#x60;, &#x60;Mandatory&#x60; (case-insensitive), or a specific category string ID.
     * @type {string}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet
     */
    readonly serviceCategory: string

    /**
     * Optional in-service group string ID. When omitted, the employee\&#39;s default group is used.
     * @type {string}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet
     */
    readonly serviceGroup?: string
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmploymentInServicePost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServicePostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServicePostRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServicePost
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {Array<EmployeeInServiceAddRequestV2>}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServicePost
     */
    readonly employeeInServiceAddRequestV2?: Array<EmployeeInServiceAddRequestV2>
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdEmploymentLicenseGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentLicenseGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentLicenseGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentLicenseGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdHeaderGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHeaderGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHeaderGetRequest {
    /**
     * The primary key identifier of the employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHeaderGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdHealthAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHealthAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHealthAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHealthAuditsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdHistoriesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet
     */
    readonly pkEmployeeId: number

    /**
     * The history type the entry will be added under (defaults to &#x60;None&#x60;, the plain pay-period walk).
     * @type {EmployeeHistoryType}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet
     */
    readonly historyType?: EmployeeHistoryType
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdHistoriesPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesPostRequest {
    /**
     * The employee identifier (authoritative; a mismatching non-zero body id is rejected).
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesPost
     */
    readonly pkEmployeeId: number

    /**
     * The TaAPI-shaped add-history request.
     * @type {AddEmployeeHistoryTypeRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesPost
     */
    readonly addEmployeeHistoryTypeRequest?: AddEmployeeHistoryTypeRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet
     */
    readonly pkEmployeeId: number

    /**
     * The employee history entry identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet
     */
    readonly employeeRecordId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDeleteRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete
     */
    readonly pkEmployeeId: number

    /**
     * The history entry identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete
     */
    readonly pkHistoryId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdHistoryTypesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryTypesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryTypesGetRequest {
    /**
     * The primary key of the target employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryTypesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdHolidayGroupPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupPut
     */
    readonly pkEmployeeId: number

    /**
     * The request containing the holiday group information.
     * @type {UpdateEmployeeHolidayGroupRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupPut
     */
    readonly updateEmployeeHolidayGroupRequest?: UpdateEmployeeHolidayGroupRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdHolidayGroupsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdJournalsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet
     */
    readonly pkEmployeeId: number

    /**
     * The employee journal entry identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet
     */
    readonly pkEmployeeJournalId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDeleteRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete
     */
    readonly pkEmployeeId: number

    /**
     * The employee journal entry identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete
     */
    readonly pkEmployeeJournalId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdJournalsPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPostRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPost
     */
    readonly pkEmployeeId: number

    /**
     * The create request.
     * @type {CreateEmployeeJournalRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPost
     */
    readonly createEmployeeJournalRequest?: CreateEmployeeJournalRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdJournalsPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPut
     */
    readonly pkEmployeeId: number

    /**
     * The update request.
     * @type {UpdateEmployeeJournalRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPut
     */
    readonly updateEmployeeJournalRequest?: UpdateEmployeeJournalRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdLaborLevelLevelGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelLevelGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelLevelGetRequest {
    /**
     * The employee identifier used to resolve the facility filter.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelLevelGet
     */
    readonly pkEmployeeId: number

    /**
     * Zero-based labor level index.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelLevelGet
     */
    readonly level: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsCheckPatchRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsCheckPatchRequest {
    /**
     * Primary key of the employee to validate against.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch
     */
    readonly pkEmployeeId: number

    /**
     * Optional: the labor level level (0-based slot, 0 to 9) the user just changed; it decides when the  PBJ Job Code is pre-filled (SPD-5249, see M:OpenShifts.IServices.Interfaces.EmployeeCenter.IFacilityEmployeeServiceV2.CheckEmployeeLaborLevelsAsync(System.Int64,System.Int64[],System.Nullable{System.Int32},System.Threading.CancellationToken)).  Any other value is a 400.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch
     */
    readonly changedLevel?: number

    /**
     * Array of exactly 10 labor level PKs to validate.
     * @type {Array<number>}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdLaborLevelsPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsPut
     */
    readonly pkEmployeeId: number

    /**
     * The request body containing exactly 10 labor level PKs (one per level 0–9) and the  effective date. Pass &#x60;0&#x60; for any level that should not be updated.
     * @type {UpdateEmployeeLaborLevelsRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsPut
     */
    readonly updateEmployeeLaborLevelsRequest?: UpdateEmployeeLaborLevelsRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdLicenseTypesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLicenseTypesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLicenseTypesGetRequest {
    /**
     * The primary key of the target employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLicenseTypesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdLockDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockDeleteRequest {
    /**
     * The primary key identifier of the employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockDelete
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdLockPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockPostRequest {
    /**
     * The primary key identifier of the employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockPost
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdLocksDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLocksDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdLocksDeleteRequest {
    /**
     * The primary key identifier of the employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdLocksDelete
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdMainGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdMainGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdMainGetRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdMainGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdMiscAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscAuditsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdMiscGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdMiscPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscPut
     */
    readonly pkEmployeeId: number

    /**
     * Fields to update.
     * @type {UpdateEmployeeMiscSettingsRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscPut
     */
    readonly updateEmployeeMiscSettingsRequest?: UpdateEmployeeMiscSettingsRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPayPeriodGroupGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayPeriodGroupGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayPeriodGroupGetRequest {
    /**
     * The employee primary key.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayPeriodGroupGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet
     */
    readonly pkEmployeeId: number

    /**
     * The employee pay rate identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet
     */
    readonly payRateId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete
     */
    readonly payRateId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPayRatePayRateIdPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdPut
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdPut
     */
    readonly payRateId: number

    /**
     * 
     * @type {EmployeePayRateUpdateRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdPut
     */
    readonly employeePayRateUpdateRequestV2?: EmployeePayRateUpdateRequestV2
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPayRatePost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePostRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePost
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {EmployeePayRateAddRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePost
     */
    readonly employeePayRateAddRequestV2?: EmployeePayRateAddRequestV2
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPayRatesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPayRatesSettingsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesSettingsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesSettingsGetRequest {
    /**
     * The employee identifier used to evaluate role-based auth.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesSettingsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPayRulePut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulePutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulePutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulePut
     */
    readonly pkEmployeeId: number

    /**
     * The request containing the pay rule information.
     * @type {UpdateEmployeePayRuleRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulePut
     */
    readonly updateEmployeePayRuleRequest?: UpdateEmployeePayRuleRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPayRulesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulesGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPayTypesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayTypesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayTypesGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayTypesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdProfilePictureGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePictureGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePictureGetRequest {
    /**
     * Primary key of the employee in the facility database.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePictureGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdProfilePicturePost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePicturePostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePicturePostRequest {
    /**
     * Primary key of the employee in the facility database.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePicturePost
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {File}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePicturePost
     */
    readonly file?: File
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPut
     */
    readonly pkEmployeeId: number

    /**
     * 
     * @type {EmployeeMainInfoUpdateRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdPut
     */
    readonly employeeMainInfoUpdateRequestV2?: EmployeeMainInfoUpdateRequestV2
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdSalariedHoursGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdSalariedHoursPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursPut
     */
    readonly pkEmployeeId: number

    /**
     * New salaried hours value.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursPut
     */
    readonly body?: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdShiftsAdjustmentPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAdjustmentPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAdjustmentPostRequest {
    /**
     * The employee identifier (overrides the body\&#39;s EmployeeId).
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAdjustmentPost
     */
    readonly pkEmployeeId: number

    /**
     * The adjustment request.
     * @type {AdjustEmployeeShift}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAdjustmentPost
     */
    readonly adjustEmployeeShift?: AdjustEmployeeShift
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdShiftsAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAuditsGet
     */
    readonly pkEmployeeId: number

    /**
     * The employee shift identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAuditsGet
     */
    readonly employeeShiftId?: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdShiftsDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsDeleteRequest {
    /**
     * The employee identifier (overrides the body\&#39;s EmployeeId).
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsDelete
     */
    readonly pkEmployeeId: number

    /**
     * The delete request.
     * @type {DeleteEmployeeShift}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsDelete
     */
    readonly deleteEmployeeShift?: DeleteEmployeeShift
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdShiftsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdShiftsPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPostRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPost
     */
    readonly pkEmployeeId: number

    /**
     * The shift to add.
     * @type {EmployeeShiftRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPost
     */
    readonly employeeShiftRequest?: EmployeeShiftRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdShiftsPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPutRequest {
    /**
     * The employee identifier (overrides the body\&#39;s EmployeeId).
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPut
     */
    readonly pkEmployeeId: number

    /**
     * The update request.
     * @type {UpdateEmployeeShift}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPut
     */
    readonly updateEmployeeShift?: UpdateEmployeeShift
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet
     */
    readonly pkEmployeeId: number

    /**
     * The employee status entry identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet
     */
    readonly employeeStatusId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdStatusesGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDeleteRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete
     */
    readonly pkEmployeeId: number

    /**
     * The status entry identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete
     */
    readonly pkEmployeeStatusId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPutRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPutRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut
     */
    readonly pkEmployeeId: number

    /**
     * The status entry identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut
     */
    readonly pkEmployeeStatusId: number

    /**
     * The update request.
     * @type {UpdateEmployeeStatusRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut
     */
    readonly updateEmployeeStatusRequest?: UpdateEmployeeStatusRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdStatusesPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPostRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPost
     */
    readonly pkEmployeeId: number

    /**
     * The add request.
     * @type {AddEmployeeStatusRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPost
     */
    readonly addEmployeeStatusRequest?: AddEmployeeStatusRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdUndoAllPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoAllPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoAllPostRequest {
    /**
     * The primary key identifier of the employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoAllPost
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdUndoPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoPostRequest {
    /**
     * The primary key identifier of the employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoPost
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdUndoSessionDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoSessionDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoSessionDeleteRequest {
    /**
     * The primary key identifier of the employee (route symmetry; the purge is session-scoped).
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoSessionDelete
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdUndoStackGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoStackGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoStackGetRequest {
    /**
     * The primary key identifier of the employee.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoStackGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdWorkPatternConfigurationGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternConfigurationGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternConfigurationGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternConfigurationGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet
     */
    readonly pkEmployeeId: number

    /**
     * The employee work pattern identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet
     */
    readonly workPatternId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdWorkPatternsGet operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsGetRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsGetRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsGet
     */
    readonly pkEmployeeId: number
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdWorkPatternsPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsPostRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsPost
     */
    readonly pkEmployeeId: number

    /**
     * Date and type of the new work pattern.
     * @type {AddEmployeeWorkPatternRequest}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsPost
     */
    readonly addEmployeeWorkPatternRequest?: AddEmployeeWorkPatternRequest
}

/**
 * Request parameters for apiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatchRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatchRequest {
    /**
     * The employee identifier.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch
     */
    readonly pkEmployeeId: number

    /**
     * The pay period identifier to validate and set as working.
     * @type {number}
     * @memberof EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch
     */
    readonly workingPayPeriodId: number
}

/**
 * Request parameters for apiV2EmployeesPost operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesPostRequest
 */
export interface EmployeeV2ApiApiV2EmployeesPostRequest {
    /**
     * Search, filter, sort, and paging options for the employee query.
     * @type {FindEmployeeRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesPost
     */
    readonly findEmployeeRequestV2?: FindEmployeeRequestV2
}

/**
 * Request parameters for apiV2EmployeesWorkPatternDelete operation in EmployeeV2Api.
 * @export
 * @interface EmployeeV2ApiApiV2EmployeesWorkPatternDeleteRequest
 */
export interface EmployeeV2ApiApiV2EmployeesWorkPatternDeleteRequest {
    /**
     * 
     * @type {DeleteEmployeeWorkPatternRequestV2}
     * @memberof EmployeeV2ApiApiV2EmployeesWorkPatternDelete
     */
    readonly deleteEmployeeWorkPatternRequestV2?: DeleteEmployeeWorkPatternRequestV2
}

/**
 * EmployeeV2Api - object-oriented interface
 * @export
 * @class EmployeeV2Api
 * @extends {BaseAPI}
 */
export class EmployeeV2Api extends BaseAPI {
    /**
     * The sibling of `checkDuplicateId`, with the same role-only authorization and the same  accepted risk: an existence probe on a non-secret, human-typed ID. It names no one. Create names  the holder when it refuses, but only after the caller\'s role at the new employee\'s labor levels  allows adding an employee with a clock ID; this call checks the JWT role alone. The answer is  the rule creation and the Clock Info tab\'s add enforce, so a free ID here is one the create call  will accept (in multi-facility mode per facility: HandPunch and Accuface route a row by its  holder\'s facility and send an all-clocks employee everywhere, so it does not rule out the same  ID under another facility). Call it while the Clock ID is typed. On submit, call create: it  refuses a taken ID with the holder\'s name and what to do, which this call cannot show.
     * @summary SPD-5664: returns whether a clock ID is already used by another employee, so the Add Employee  form can warn while the ID is typed instead of after the employee is saved.
     * @param {EmployeeV2ApiApiV2EmployeesCheckDuplicateClockIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesCheckDuplicateClockIdGet(requestParameters: EmployeeV2ApiApiV2EmployeesCheckDuplicateClockIdGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesCheckDuplicateClockIdGet(requestParameters.clockId, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authorization is role-only (the `[Authorize(Roles = ...)]` below) — unlike the create  path\'s `CheckLaborLevelAuthorizationAsync`, nothing here verifies the caller has any standing  at facilityId itself. A FacilityManager (or Support/Admin/System) token  scoped to one facility can pass a different facilityId and probe  employee-ID existence there, and in single-facility mode an omitted facilityId  answers tenant-wide. Accepted deliberately, matching `nextAvailableId`\'s existing,  already-shipped shape (SPD-5697 review) — this is an existence probe on a non-secret,  human-typed ID, not a data read, and tightening it would mean duplicating the labor-level  authorization engine on a read endpoint. Revisit if that calculus changes.
     * @summary Returns whether the given employee ID is already in use within a facility.
     * @param {EmployeeV2ApiApiV2EmployeesCheckDuplicateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesCheckDuplicateIdGet(requestParameters: EmployeeV2ApiApiV2EmployeesCheckDuplicateIdGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesCheckDuplicateIdGet(requestParameters.employeeId, requestParameters.facilityId, requestParameters.excludePkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns clock-info permission flags for the logged-in user given exactly 10 labor-level IDs.  Mirrors ta-web `POST /api/Employee/AddClockPermission`.
     * @param {EmployeeV2ApiApiV2EmployeesClockInfoPermissionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesClockInfoPermissionsPost(requestParameters: EmployeeV2ApiApiV2EmployeesClockInfoPermissionsPostRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesClockInfoPermissionsPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new employee (heaviest write-side port of TaAPI `EmployeeController.CreateEmployee`).
     * @param {EmployeeV2ApiApiV2EmployeesCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesCreatePost(requestParameters: EmployeeV2ApiApiV2EmployeesCreatePostRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesCreatePost(requestParameters.createEmployeeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The facility\'s custom-tab definitions: tabs, fields and dropdown options. Carries no  employee id, so the class-level `RequireSelfOrManager` filter no-ops here and the  caller\'s own `EmployeeCustomView` is the gate.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesCustomTabsGet(options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesCustomTabsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the Licensing tab. Replaces TaAPI  `PUT /api/Employee/Employment/EmployeeLicense`. Returns the hydrated  OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeLicenseResponse.
     * @param {EmployeeV2ApiApiV2EmployeesEmploymentEmployeeLicensePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesEmploymentEmployeeLicensePut(requestParameters: EmployeeV2ApiApiV2EmployeesEmploymentEmployeeLicensePutRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesEmploymentEmployeeLicensePut(requestParameters.employeeLicenseUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the General employment tab. Replaces TaAPI  `PUT /api/Employee/Employment/General`. Returns `true` on success.
     * @param {EmployeeV2ApiApiV2EmployeesEmploymentGeneralPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesEmploymentGeneralPut(requestParameters: EmployeeV2ApiApiV2EmployeesEmploymentGeneralPutRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesEmploymentGeneralPut(requestParameters.employeeEmploymentGeneralUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the Health tab. Replaces TaAPI `PUT /api/Employee/Employment/Health`.  Returns the hydrated OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeHealthResponse.
     * @param {EmployeeV2ApiApiV2EmployeesEmploymentHealthPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesEmploymentHealthPut(requestParameters: EmployeeV2ApiApiV2EmployeesEmploymentHealthPutRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesEmploymentHealthPut(requestParameters.employeeHealthUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the I-9 Documents tab. Replaces TaAPI  `PUT /api/Employee/Employment/I9Documents`. Returns the hydrated  OpenShifts.BusinessObjects.Response.EmployeeCenter.EmployeeI9DocumentsResponse.
     * @param {EmployeeV2ApiApiV2EmployeesEmploymentI9DocumentsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesEmploymentI9DocumentsPut(requestParameters: EmployeeV2ApiApiV2EmployeesEmploymentI9DocumentsPutRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesEmploymentI9DocumentsPut(requestParameters.employeeI9DocumentsUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the authorized employee groups for the current employee based on the provided grouping and filter request.
     * @param {EmployeeV2ApiApiV2EmployeesGroupsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesGroupsPost(requestParameters: EmployeeV2ApiApiV2EmployeesGroupsPostRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesGroupsPost(requestParameters.findEmployeeGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the labor levels for the given filter type used for employee filtering.  Replaces ta-web\'s `GET /api/Employee/BudgetGroupLaborLevelsForFilter` and  `GET /api/Employee/DepartmentLaborLevelsForFilter`.
     * @param {EmployeeV2ApiApiV2EmployeesLaborLevelsForFilterTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesLaborLevelsForFilterTypeGet(requestParameters: EmployeeV2ApiApiV2EmployeesLaborLevelsForFilterTypeGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesLaborLevelsForFilterTypeGet(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Release All Locks — every lock, every owner. Gated on the caller\'s legacy TA role being  the Administrator built-in (`Role.IsAdministrator`), matching LegacyApp, which only  shows this command when `role.IsAdministrator` (MainFormRibbonSetup.cs:136-137). The  check runs in the service; an identity-role restriction here would 403 every facility  caller, because `UserRoles.Admin` is a SaaS platform role facility users never carry  (SPD-5803).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesLocksDelete(options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesLocksDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Release My Locks — all of the caller\'s locks, all sessions (legacy built-in).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesLocksMineDelete(options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesLocksMineDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns identity and role-flag details for the currently authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesMeGet(options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesMeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the signed-in employee\'s own personal info (emergency contact, home address, email,  home phone) for the mobile / self-service surface.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesMePersonalInfoGet(options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesMePersonalInfoGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Self-service update of the authenticated employee\'s own personal info — address, emergency  contact, email and home phone. The caller is resolved from the JWT (mobile `me` route),  and the mobile client wraps its payload in a `body` envelope. Ports the mobile contact  update that had no V2 equivalent (SPD-5482).
     * @param {EmployeeV2ApiApiV2EmployeesMePersonalInfoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesMePersonalInfoPut(requestParameters: EmployeeV2ApiApiV2EmployeesMePersonalInfoPutRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesMePersonalInfoPut(requestParameters.updatePersonalInfoRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authorization is role-only — nothing verifies the caller has any standing at  facilityId itself. Same accepted-risk decision as `checkDuplicateId`  (SPD-5697 review): an existence probe on a non-secret, human-typed ID, not a data read.
     * @summary Returns the next available employee ID within a facility.
     * @param {EmployeeV2ApiApiV2EmployeesNextAvailableIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesNextAvailableIdGet(requestParameters: EmployeeV2ApiApiV2EmployeesNextAvailableIdGetRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesNextAvailableIdGet(requestParameters.facilityId, requestParameters.startingFrom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the accrual group for the specified employee with an effective date.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAccrualGroupPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAccrualGroupPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeAccrualGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all accrual groups accessible to the specified employee,  filtered by the employee\'s facility.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAccrualGroupsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAccrualGroupsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAccrualGroupsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The returned labor levels are filtered based on the employee\'s facility.  This endpoint always returns HTTP 200 with a consistent response shape.  Caching must be scoped per authenticated user and employee.
     * @summary Returns all labor levels available to the specified employee,  grouped by labor level index.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAllLaborLevelsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAllLaborLevelsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAllLaborLevelsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAllLaborLevelsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the Employee entity itself,  ordered by database timestamp ascending.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the data behind the employee\'s Authorizations tab — the  EmployeeAuthorization record merged with every EmployeeAuthorizationLaborLevel row —  ordered by database timestamp ascending (SPD-5600).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuthorizationAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuthorizationAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disables (soft-deletes) the authorization for the specified employee. Mirrors TaAPI  `DELETE {employeeId}/Authorization`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuthorizationDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuthorizationDelete(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns authorization settings and role-based permission flags for the specified employee.  When the caller\'s role lacks view permission, returns 200 with  `IsAuthorizationTabVisible = false` and all other fields at defaults.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuthorizationGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuthorizationGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Clones an existing labor-level row on the employee\'s authorization into a new row.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelAuthorizationLaborLevelIdClonePost(requestParameters.pkEmployeeId, requestParameters.authorizationLaborLevelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-deletes a labor-level row from the employee\'s authorization.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdDelete(requestParameters.pkEmployeeId, requestParameters.laborLevelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a labor-level row on the employee\'s authorization. `EmployeeId` and  `AuthorizationLaborLevelId` are taken from the route, overriding the body.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelLaborLevelIdPut(requestParameters.pkEmployeeId, requestParameters.laborLevelId, requestParameters.updateEmployeeAuthorizationLaborLevelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a new labor-level row to the employee\'s authorization. `EmployeeId` is taken  from the route, overriding the body.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuthorizationLaborLevelPost(requestParameters.pkEmployeeId, requestParameters.addEmployeeAuthorizationLaborLevelRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Enables authorization for the specified employee (creates an authorization record with  generated defaults). Mirrors TaAPI `POST {employeeId}/Authorization`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuthorizationPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuthorizationPost(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the authorization details for the specified employee. Mirrors TaAPI  `PUT {employeeId}/Authorization`: the route employee ID overwrites the body\'s.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuthorizationPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuthorizationPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeAuthorizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the role IDs available for the employee authorization combobox.  Always includes \"No Authorization (Built In)\"; includes \"Administrator (Built In)\"  only when the caller is an administrator.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationRolesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdAuthorizationRolesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdAuthorizationRolesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdAuthorizationRolesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the base schedule group for the specified employee with an effective date.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdBaseScheduleGroupPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdBaseScheduleGroupPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeBaseScheduleGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all base schedule groups accessible to the specified employee,  filtered by the employee\'s facility.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdBaseScheduleGroupsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdBaseScheduleGroupsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdBaseScheduleGroupsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assigns or unassigns all facility-matched time clocks to/from the clock ID at the given index  by toggling the `AssignAllTimeClocks` flag and clearing all individual assignment rows.  Mirrors ta-web `PATCH /api/Employee/EmployeeClockInfo/AssignmentAll`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatchRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdClockInfoAssignmentAllPatch(requestParameters.pkEmployeeId, requestParameters.index, requestParameters.setEmployeeClockInfoAllAssignmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assigns or unassigns a single time clock to/from the clock ID at the given index.  Mirrors ta-web `PATCH /api/Employee/EmployeeClockInfo/Assignment`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatchRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdClockInfoAssignmentsPatch(requestParameters.pkEmployeeId, requestParameters.index, requestParameters.setEmployeeClockInfoAssignmentsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee clock info entry.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdClockInfoClockIndexAuditsGet(requestParameters.pkEmployeeId, requestParameters.clockIndex, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the time clocks accessible to the specified employee based on facility matching.  An inactive clock, or one of an inactive group, is listed only while it is explicitly  assigned, flagged `isInactive` (SPD-6024).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdClockInfoFacilityTimeClocksGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns clock ID info for the specified employee at the given index.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdClockInfoGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdClockInfoGet(requestParameters.pkEmployeeId, requestParameters.index, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the labor level IDs stored on the clock ID at the given index for an employee.  Requires `AllowMultipleClockIDs` to be enabled.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsGet(requestParameters.pkEmployeeId, requestParameters.index, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Writes the 10-element labor level FK array onto the clock ID at the given index.  Mirrors ta-web `PUT /api/Employee/EmployeeClockInfo/LaborLevels`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdClockInfoLaborLevelsPut(requestParameters.pkEmployeeId, requestParameters.index, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lists every clock ID belonging to the specified employee, in the order the clock-scoped  endpoints index them.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdClockInfoListGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoListGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdClockInfoListGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a new clock ID record for the specified employee.  Mirrors ta-web `POST /api/Employee/EmployeeClockInfo`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdClockInfoPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdClockInfoPost(requestParameters.pkEmployeeId, requestParameters.addEmployeeClockInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing clock ID record for the specified employee.  Mirrors ta-web `PUT /api/Employee/EmployeeClockInfo`.  Only non-null request fields are applied (patch semantics).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdClockInfoPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdClockInfoPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdClockInfoPut(requestParameters.pkEmployeeId, requestParameters.clockIndex, requestParameters.updateEmployeeClockInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the data behind the employee\'s Contact tab — the  EmployeeExtended record (address / emergency contact fields) merged with every  EmployeeContact row (phones / email) — ordered by database timestamp ascending (SPD-5600).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdContactInfoAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdContactInfoAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the contact information and role-based permission flags for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdContactInfoGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdContactInfoGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the contact information for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdContactInfoPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdContactInfoPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdContactInfoPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeContactInfoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The employee\'s custom-field values, each with the raw stored string and the typed  projections LegacyApp\'s converters produce. Self-or-manager guarded via the class-level  `RequireSelfOrManager(\"pkEmployeeId\")` filter, then the caller\'s  `EmployeeCustomView` for this employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdCustomValuesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdCustomValuesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Batch write for the employee\'s custom values with LegacyApp\'s employee-form semantics:  singleton/cell upserts, historical-group row adds (one shared key per row set), and  group removals. Values are stored in the exact strings legacy\'s controls write, so the  WinForms app renders web edits untouched.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdCustomValuesPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdCustomValuesPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdCustomValuesPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeCustomValuesRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the effective-date UI configuration for the given employee and effective date type.  Equivalent to ta-web\'s `GET /api/Employee/EffectiveDateConfiguration`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEffectiveDateConfigurationGet(requestParameters.pkEmployeeId, requestParameters.effectiveDateType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the employee ID for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmployeeIdPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeIdPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmployeeIdPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee\'s licensing record.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmployeeLicenseAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the employee status types available for the given employee\'s role.  Mirrors ta-web\'s `GET /api/Employee/{employeeId}/EmployeeStatusTypeList`.  When the role has `EmployeeStatusesNoTerminatedStatusTypes` set, only  `ConsideredHired` types are returned; otherwise all types are returned.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeStatusTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmployeeStatusTypesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmployeeStatusTypesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmployeeStatusTypesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the employment audit records for the specified employee,  ordered by database timestamp ascending.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmploymentAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmploymentAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-deletes a single in-service row. Replaces TaAPI  `DELETE /api/Employee/{employeeId}/Employment/EmployeeInService/{inServiceId}`.  Returns a boolean (TaAPI parity).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServiceInServiceIdDelete(requestParameters.pkEmployeeId, requestParameters.inServiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee in-service entry,  ordered by database timestamp ascending (SPD-5600).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesEmployeeInServiceIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.employeeInServiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all in-service records taken by the specified employee,  each with its in-service definition including mandatory and taken flags.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmploymentEmployeeInServicesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns general employment data and permission flags for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentGeneralGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmploymentGeneralGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentGeneralGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmploymentGeneralGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the health record and UI configuration for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentHealthGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmploymentHealthGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentHealthGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmploymentHealthGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the I-9 documents and employment eligibility details for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmploymentI9DocumentsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the in-service list for the specified employee with mandatory and taken flags.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmploymentInServiceListServiceCategoryGet(requestParameters.pkEmployeeId, requestParameters.serviceCategory, requestParameters.serviceGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds one or more in-service records. Replaces TaAPI  `POST /api/Employee/{employeeId}/Employment/InService`. Returns the count of  successfully inserted rows (TaAPI parity — partial success).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServicePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmploymentInServicePost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentInServicePostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmploymentInServicePost(requestParameters.pkEmployeeId, requestParameters.employeeInServiceAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the licensing information and role-based permission flags for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentLicenseGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdEmploymentLicenseGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdEmploymentLicenseGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdEmploymentLicenseGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the header details for the specified employee. Opening someone in  Employee Center (and creating an employee) records them on the caller\'s  Recently Viewed list (SPD-4205). A recording failure is logged and does not  fail the header response.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHeaderGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdHeaderGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHeaderGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdHeaderGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee\'s health record.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHealthAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdHealthAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHealthAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdHealthAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the history records and role-based permission flags for the specified employee.  Always returns 200 — use `IsEmployeeHistoryGridVisible` to determine view access.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdHistoriesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdHistoriesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the minimum effective date the add-history modal may use for the given history  type — the caller-role-aware port of TaAPI `POST /api/Employee/minhistorydate`  (ta-legacy `PayPeriodGroup.StartDateOfEarliestOpenPayPeriodForLoggedIn`): the start of  the pay period following the employee\'s latest closed-or-approved period, with the  historical-edit carve-outs (labor levels / accrual group) returning 2001-01-01.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdHistoriesMinEffectiveDateGet(requestParameters.pkEmployeeId, requestParameters.historyType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a history entry (labor level, pay rule, base schedule group, holiday group, or  accrual group) for the specified employee at an effective date.  Committing port of TaAPI `POST /api/Employee/AddHistoryType`: ta-web only stages the  insert in its session unit of work (committed exclusively by the SaveEmployee flow the web  FE removed), so the row never reaches the tenant DB — this endpoint persists atomically.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdHistoriesPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoriesPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdHistoriesPost(requestParameters.pkEmployeeId, requestParameters.addEmployeeHistoryTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee history entry,  ordered by database timestamp ascending.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdHistoryEmployeeRecordIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.employeeRecordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes the specified history entry for the given employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdHistoryPkHistoryIdDelete(requestParameters.pkEmployeeId, requestParameters.pkHistoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the available history types and their selectable values for the specified employee.  Each entry contains a history type (e.g., a configured labor level, PayRule, BaseScheduleGroup)  and the values the employee may select from, filtered by facility and role.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdHistoryTypesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHistoryTypesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdHistoryTypesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the holiday group for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdHolidayGroupPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdHolidayGroupPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeHolidayGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all holiday groups accessible to the specified employee,  filtered by the employee\'s facility.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdHolidayGroupsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdHolidayGroupsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdHolidayGroupsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the journal entries and role-based permission flags for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdJournalsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdJournalsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee journal entry,  ordered by database timestamp ascending (SPD-5600).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.pkEmployeeJournalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes the specified employee journal entry.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdJournalsPkEmployeeJournalIdDelete(requestParameters.pkEmployeeId, requestParameters.pkEmployeeJournalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new employee journal entry for the specified employee, based on the provided request data.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdJournalsPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdJournalsPost(requestParameters.pkEmployeeId, requestParameters.createEmployeeJournalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing employee journal entry for the specified employee, based on the provided request data.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdJournalsPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdJournalsPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdJournalsPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeJournalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the labor levels at the specified index, filtered to those that belong to  the employee\'s facility (multi-facility environments only).  Equivalent to ta-web\'s `GET /api/Employee/{employeeId}/LaborLevel/{level}`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelLevelGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdLaborLevelLevelGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelLevelGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdLaborLevelLevelGet(requestParameters.pkEmployeeId, requestParameters.level, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validates and normalizes a proposed set of labor level IDs for an employee without persisting  any changes. Mirrors ta-web `PATCH /api/Employee/EmployeeLaborLevelsCheck`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsCheckPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsCheckPatchRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdLaborLevelsCheckPatch(requestParameters.pkEmployeeId, requestParameters.changedLevel, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the labor levels for the specified employee with an effective date.  Replaces ta-web `PUT /api/Employee/EmployeeLaborLevels`.  Requires `EmployeeMainEdit` on the caller\'s role.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdLaborLevelsPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLaborLevelsPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdLaborLevelsPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeLaborLevelsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the license types available for the specified employee\'s facility state,  as a dictionary of `LicenseType` integer value to friendly display name.  Always includes `Unknown` and `NotApplicable`, followed by state-specific types.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLicenseTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdLicenseTypesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLicenseTypesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdLicenseTypesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Releases the caller\'s own lock on this employee (navigate away / deselect).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdLockDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdLockDelete(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lock-on-view acquire/refresh (SPD-5570). Returns holder info instead of erroring on  conflict.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdLockPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLockPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdLockPost(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Release Current Employee\'s Locks — even others\'; requires legacy  `Role.AllowReleasingOfLock`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdLocksDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdLocksDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdLocksDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdLocksDelete(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the narrow projection consumed by the Employee Settings → Main tab. Replaces  the legacy TaAPI `GET /api/Employee/{pkEmployeeId}?doRefreshEmployee=...`: the FE  only binds ~25 of the 100+ fields from the legacy detail dump, so this endpoint returns  just those. SaaSAPI is stateless per request, so the `doRefreshEmployee`  cache-bypass parameter is dropped — every call is fresh.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdMainGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdMainGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdMainGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdMainGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee\'s miscellaneous settings (extended) record.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdMiscAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdMiscAuditsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns miscellaneous settings for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdMiscGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdMiscGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates miscellaneous settings for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdMiscPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdMiscPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdMiscPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeMiscSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the pay period group assigned to the employee via their pay rule.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayPeriodGroupGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPayPeriodGroupGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayPeriodGroupGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPayPeriodGroupGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee pay rate entry.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPayRatePayRateIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.payRateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-deletes a single pay-rate row. Replaces TaAPI  `DELETE /api/Employee/{employeeId}/PayRate/{payRateId}`. Returns `true` when  a row was removed, `false` when no matching row existed (TaAPI parity).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPayRatePayRateIdDelete(requestParameters.pkEmployeeId, requestParameters.payRateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replaces TaAPI `PUT /api/Employee/{employeeId}/PayRate/{payRateId}`. Updates the  `PayTypeId` / `ShiftId` / `Note` on an existing pay-rate row. The route  pkEmployeeId and payRateId overwrite the body\'s  `EmployeeId` and `Id` respectively (TaAPI parity). Requires  `EmployeePayRatesAdd` on the caller\'s role.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPayRatePayRateIdPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePayRateIdPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPayRatePayRateIdPut(requestParameters.pkEmployeeId, requestParameters.payRateId, requestParameters.employeePayRateUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replaces TaAPI `POST /api/Employee/PayRate`. Adds a new `EmployeePayRate` row;  returns the new PK. Requires `EmployeePayRatesAdd` on the caller\'s role.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPayRatePost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatePostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPayRatePost(requestParameters.pkEmployeeId, requestParameters.employeePayRateAddRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the pay rates and role-based permission flags for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPayRatesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPayRatesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns facility-wide pay rate configuration settings and whether the caller  has permission to view pay rates for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesSettingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPayRatesSettingsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRatesSettingsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPayRatesSettingsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the pay rule for the specified employee with an effective date.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPayRulePut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulePutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPayRulePut(requestParameters.pkEmployeeId, requestParameters.updateEmployeePayRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all pay rules accessible to the specified employee,  filtered by the employee\'s facility and role-based restrictions.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPayRulesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayRulesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPayRulesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all pay types accessible to the specified employee,  filtered by facility binding and role-based restrictions.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPayTypesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPayTypesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPayTypesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accessible to managers (FacilityManager, Admin, System, Support) acting on any employee,  and to an authenticated Employee acting on themselves — enforced by OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute.
     * @summary Returns a time-limited SAS URL for the employee\'s profile picture.  The URL validity period is controlled by `ProfilePictureServiceV2.SasExpiry`.  The underlying filename is resolved from an in-memory cache and only falls back  to a database query on a cache miss.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePictureGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdProfilePictureGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePictureGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdProfilePictureGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accessible to managers (FacilityManager, Admin, System, Support) acting on any employee,  and to an authenticated Employee uploading their own picture — enforced by OpenShifts.WebApi.Filters.RequireSelfOrManagerAttribute.
     * @summary Uploads a new profile picture for the employee, saves the filename to the facility  database, and refreshes the in-memory cache so subsequent GET requests immediately  reflect the new image.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePicturePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdProfilePicturePost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdProfilePicturePostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdProfilePicturePost(requestParameters.pkEmployeeId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the employee\'s first/middle/last name + tag. Replaces TaAPI  `PUT /api/Employee`. Requires `EmployeeMainEdit` on the caller\'s role.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdPut(requestParameters.pkEmployeeId, requestParameters.employeeMainInfoUpdateRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the salaried hours for the specified employee.  The value is stored as minutes in the database and returned as hours (minutes / 60).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdSalariedHoursGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdSalariedHoursGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the salaried hours for the specified employee.  The value is stored as minutes in the database (round(hours * 60)).
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdSalariedHoursPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdSalariedHoursPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdSalariedHoursPut(requestParameters.pkEmployeeId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolves the appropriate employee shift type for a candidate shift without persisting.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAdjustmentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdShiftsAdjustmentPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAdjustmentPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdShiftsAdjustmentPost(requestParameters.pkEmployeeId, requestParameters.adjustEmployeeShift, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee shift.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdShiftsAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdShiftsAuditsGet(requestParameters.pkEmployeeId, requestParameters.employeeShiftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes one or more shifts from the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdShiftsDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdShiftsDelete(requestParameters.pkEmployeeId, requestParameters.deleteEmployeeShift, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all shifts for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdShiftsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdShiftsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a single shift to the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdShiftsPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdShiftsPost(requestParameters.pkEmployeeId, requestParameters.employeeShiftRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates the shift and/or shift-type assignment of an existing employee shift.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdShiftsPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdShiftsPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdShiftsPut(requestParameters.pkEmployeeId, requestParameters.updateEmployeeShift, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee status entry.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdStatusEmployeeStatusIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.employeeStatusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the statuses and role-based permission flags for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdStatusesGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdStatusesGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes the specified employee status entry and its associated comment.  Mirrors ta-web `DELETE /api/Employee/Status`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdDelete(requestParameters.pkEmployeeId, requestParameters.pkEmployeeStatusId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing employee status entry (hire-date flag, PBJ status type, comment).  Mirrors ta-web `PUT /api/Employee/Status`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPutRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdStatusesPkEmployeeStatusIdPut(requestParameters.pkEmployeeId, requestParameters.pkEmployeeStatusId, requestParameters.updateEmployeeStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a new status entry for the specified employee.  Mirrors ta-web `POST /api/Employee/AddStatus`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdStatusesPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdStatusesPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdStatusesPost(requestParameters.pkEmployeeId, requestParameters.addEmployeeStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reverses the caller\'s ENTIRE remaining micro-session undo stack for this employee in one  all-or-nothing operation.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoAllPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdUndoAllPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoAllPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdUndoAllPost(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reverses the most recent remaining action in the caller\'s micro-session undo stack for  this employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdUndoPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdUndoPost(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ends the caller\'s undo micro-session for this employee view: purges the session\'s whole  stack. Fired by the FE on Profile-tab enter and on leaving the employee center. No lock  required — it can only destroy the caller\'s own history. Idempotent; 204 also when no  micro-session header rides the request.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoSessionDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdUndoSessionDelete(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoSessionDeleteRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdUndoSessionDelete(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the caller\'s micro-session undo stack for this employee, newest-first.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoStackGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdUndoStackGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdUndoStackGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdUndoStackGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the shift and work-pattern UI permission flags for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternConfigurationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdWorkPatternConfigurationGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternConfigurationGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdWorkPatternConfigurationGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the audit records for the specified employee work pattern entry.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdWorkPatternWorkPatternIdAuditsGet(requestParameters.pkEmployeeId, requestParameters.workPatternId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the work patterns for the specified employee.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdWorkPatternsGet(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsGetRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdWorkPatternsGet(requestParameters.pkEmployeeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Adds a new work pattern entry for the employee.  Mirrors ta-web `POST /api/Employee/{employeeId}/workpattern`.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdWorkPatternsPost(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkPatternsPostRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdWorkPatternsPost(requestParameters.pkEmployeeId, requestParameters.addEmployeeWorkPatternRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validates the requested pay period belongs to the employee and returns the recalculate-button state.
     * @param {EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch(requestParameters: EmployeeV2ApiApiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatchRequest, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPkEmployeeIdWorkingPayPeriodWorkingPayPeriodIdPatch(requestParameters.pkEmployeeId, requestParameters.workingPayPeriodId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves the authorized employees for the logged-in employee and returns the grouped result set.
     * @param {EmployeeV2ApiApiV2EmployeesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesPost(requestParameters: EmployeeV2ApiApiV2EmployeesPostRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesPost(requestParameters.findEmployeeRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Landing-page snapshot for Time & Attendance widgets: hours, OT, approaching OT,  punched in, and pending punch requests (missing-punch and time-change notifications  from the app — not absence/PTO). Scoped to employees the caller can view.  Hours dates come from the caller\'s pay-period group for every facility row.  Approaching OT is Hours that count toward period overtime (the pay type\'s  `…CountTowardsPeriodOvertime` flags, as in legacy), summed over each employee\'s own  current overtime period, vs that period\'s threshold (an employee with no period-OT rule is  left out, as legacy\'s 99999 \"never approaching\" does), for employees whose Hours the caller may  view. The pay periods are the ones containing today, not legacy\'s working and previous periods.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesTaDashboardGet(options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesTaDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Soft-deletes one or more `EmployeeWorkPattern` rows. Replaces TaAPI  `DELETE /api/Employee/workpattern`. Returns 204 No Content on success.
     * @param {EmployeeV2ApiApiV2EmployeesWorkPatternDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeV2Api
     */
    public apiV2EmployeesWorkPatternDelete(requestParameters: EmployeeV2ApiApiV2EmployeesWorkPatternDeleteRequest = {}, options?: AxiosRequestConfig) {
        return EmployeeV2ApiFp(this.configuration).apiV2EmployeesWorkPatternDelete(requestParameters.deleteEmployeeWorkPatternRequestV2, options).then((request) => request(this.axios, this.basePath));
    }
}
